(function(){
const VERSION = "2026-10-22-palettes";
const CONSENT_VERSION = "2026-10-08.2";
const CONSENT =
  "Chcem aj dva tipy a mesačné novinky Keyany e-mailom. Odber je dobrovoľný, odhlásiť sa môžem kedykoľvek.";
const SEASONS = ["jar", "leto", "jesen", "zima"];
const SEASON_NAMES = {
  jar: "Jar",
  leto: "Leto",
  jesen: "Jeseň",
  zima: "Zima",
};
const CONSULTATION_URL =
  "https://www.keyana.sk/pages/kontakt#contact_form";
const CONSULTATION = {
  heading: "Od orientačného výsledku k Vašim osobným farbám",
  description:
    "Kvíz je prvý krok. Pri osobnej konzultácii s Jankou Keketi, imidžovou poradkyňou a zakladateľkou KEYANA, spresníte svoju farebnú sezónu aj zaradenie do jedného z 12 podtypov.",
  detail:
    "Získate odporúčania na odtiene oblečenia, líčenia a vlasov. Janka Vám pomôže aj s výberom hodvábnej šatky, ktorej farby vyniknú pri Vašej tvári.",
  action: "Dohodnúť konzultáciu s Jankou",
  note: "Vo formulári napíšte, že máte záujem o osobnú farebnú typológiu. Termín si dohodnete priamo s Jankou.",
};
// Scores transcribed from Janka's 13 October 2026 final V1.1 brief.
// Column order is Jar, Leto, Jeseň, Zima.
const option = (value, label, points, colors = []) => ({
  value,
  label,
  points,
  colors,
});
const QUESTIONS = [
  {
    id: "q1",
    label: "Aká je vaša prirodzená farba vlasov?",
    help: "Vyberte farbu bez farbenia alebo melíru.",
    options: [
      option(
        "A",
        "Svetlá blond až svetlohnedá so zlatistým alebo medovým nádychom",
        [2, 0, 1, 0],
      ),
      option(
        "B",
        "Popolavá blond až svetlá alebo stredná popolavohnedá",
        [0, 2, 0, 0],
      ),
      option(
        "C",
        "Medená, gaštanová, zlatohnedá alebo teplá hnedá",
        [1, 0, 2, 0],
      ),
      option("D", "Tmavohnedá až čierna", [0, 0, 1, 1]),
    ],
  },
  {
    id: "q2",
    label: "Ako by ste najlepšie opísali svoje oči?",
    help: "",
    options: [
      option(
        "A",
        "Svetlé a jemné – sivé, sivomodré, jemné zelené",
        [0, 2, 0, 0],
      ),
      option(
        "B",
        "Jasné a výrazné – jasnomodré, výrazne zelené, tyrkysové",
        [1, 0, 0, 2],
      ),
      option(
        "C",
        "Zelené, zeleno-sivé, modrozelené alebo viacfarebné",
        [1, 1, 0, 0],
      ),
      option(
        "D",
        "Orieškové, olivové, jantárové alebo teplé hnedé",
        [1, 0, 2, 0],
      ),
      option("E", "Tmavohnedé až veľmi tmavé", [0, 0, 1, 2]),
    ],
  },
  {
    id: "q3",
    label: "Ktoré farby vám pri tvári pristanú viac?",
    help: "Porovnajte farebné palety podľa toho, ako pôsobia pri vašej tvári.",
    visual: "temperature",
    options: [
      option(
        "A",
        "Teplejšie – napr. koralová, marhuľová, teplá zelená",
        [4, 0, 4, 0],
        [
          "#f4a18b",
          "#f4b286",
          "#f4cf77",
          "#e9ac43",
          "#83955d",
          "#35847b",
          "#bd6739",
          "#d64e3c",
        ],
      ),
      option(
        "B",
        "Skôr teplejšie, ale dobre nosím aj chladnejšie farby",
        [3, 2, 1, 0],
        [
          "#efc0b8",
          "#e9c7ae",
          "#f4d789",
          "#9da98e",
          "#64979f",
          "#63859e",
          "#b37e90",
          "#b94866",
        ],
      ),
      option(
        "C",
        "Skôr chladnejšie, ale dobre nosím aj teplejšie farby",
        [2, 3, 0, 1],
        [
          "#ebb1c5",
          "#c1a8d8",
          "#a5a8de",
          "#9bc5df",
          "#82b7a4",
          "#809981",
          "#b988a3",
          "#eb9aaa",
        ],
      ),
      option(
        "D",
        "Chladnejšie – napr. malinová, levanduľová, chladná modrá",
        [0, 4, 0, 4],
        [
          "#d65a98",
          "#bd468c",
          "#ae8dc7",
          "#7487cc",
          "#245d9d",
          "#087686",
          "#559698",
          "#512b78",
        ],
      ),
      option("E", "Neviem posúdiť", [0, 0, 0, 0]),
    ],
  },
  {
    id: "q4",
    label: "Pristanú vám viac svetlejšie alebo tmavšie farby?",
    help: "Myslite iba na to, ako svetlá alebo tmavá je farba – nie na to, či je jemná alebo výrazná.",
    visual: "lightness",
    options: [
      option(
        "A",
        "Skôr svetlejšie – veľmi tmavé farby ma často zatienia",
        [3, 3, 0, 0],
        [
          "#f5eadb",
          "#efd4d6",
          "#f0c9ae",
          "#f5e6bd",
          "#abd3c8",
          "#acd2e8",
          "#b8bee4",
          "#d4bfdf",
          "#b3c4d4",
          "#d4cfc7",
        ],
      ),
      option(
        "B",
        "Niečo medzi – najlepšie mi pristanú stredne svetlé až stredne tmavé farby",
        [1, 1, 1, 1],
        [
          "#ce9ca8",
          "#bd7f95",
          "#9c8390",
          "#819d89",
          "#56765b",
          "#749cb6",
          "#547d9e",
          "#a38ca7",
          "#b6948f",
          "#bda087",
        ],
      ),
      option(
        "C",
        "Skôr tmavšie – svetlé farby pri mne často pôsobia príliš slabo",
        [0, 0, 3, 3],
        [
          "#6d1835",
          "#611532",
          "#44233e",
          "#285740",
          "#716a3e",
          "#123c62",
          "#125574",
          "#095a64",
          "#51372a",
          "#754829",
        ],
      ),
      option("D", "Neviem posúdiť", [0, 0, 0, 0]),
    ],
  },
  {
    id: "q5",
    label: "Pristanú vám viac jemné alebo sýte farby?",
    help: "Teraz nejde o svetlosť. Všímajte si, či farby pôsobia tlmene alebo žiarivo.",
    visual: "saturation",
    options: [
      option(
        "A",
        "Jemné a tlmené – výrazné farby ma často prebijú",
        [0, 3, 2, 0],
        [
          "#e8c9c9",
          "#cbb0b7",
          "#b3a3b0",
          "#c9cad4",
          "#98b2a4",
          "#8ea9b5",
          "#7698aa",
          "#9eafa0",
          "#aca89b",
          "#99928b",
        ],
      ),
      option(
        "B",
        "Niečo medzi – ani veľmi tlmené, ani veľmi sýte",
        [1, 1, 1, 1],
        [
          "#db99a3",
          "#ce878e",
          "#c77e7c",
          "#efbd65",
          "#98a46b",
          "#4d7fac",
          "#489298",
          "#a590bd",
          "#ab819c",
          "#b57365",
        ],
      ),
      option(
        "C",
        "Sýte a žiarivé – výrazné farby ma neprebíjajú, moja tvár pri nich vynikne",
        [2, 0, 1, 3],
        [
          "#ed5d9b",
          "#cb1f27",
          "#f47c20",
          "#f7b421",
          "#098c48",
          "#1784c7",
          "#054991",
          "#008492",
          "#932784",
          "#4b2775",
        ],
      ),
      option("D", "Neviem posúdiť", [0, 0, 0, 0]),
    ],
  },
];
const PALETTES = {
  jar: {
    title: "Ako prvú vyskúšajte jarnú paletu",
    description:
      "Teplejšie, čisté odtiene môžu nechať vyniknúť vašu tvár. Začnite jedným farebným akcentom.",
    colors: [
      ["Koralová", "#f07979"],
      ["Tyrkysová", "#00c9c1"],
      ["Marhuľková", "#feb28c"],
      ["Krémová", "#fbefdb"],
      ["Žltá", "#fec840"],
      ["Béžová", "#d1a568"],
    ],
    collections: ["jarny-typ"],
    accent: "koralový alebo teplejší tyrkysový",
    reason: "Teplejšie, jasnejšie farby nadväzujú na jarnú paletu.",
  },
  leto: {
    title: "Ako prvú vyskúšajte letnú paletu",
    description:
      "Chladnejšie a tlmenejšie odtiene môžu pôsobiť jemne a harmonicky. Skúste staroružovú, levanduľovú či mäkkú modrú.",
    colors: [
      ["Ružová", "#efc0d2"],
      ["Levanduľová", "#a890de"],
      ["Pastelová modrá", "#8fc7ea"],
      ["Bledo sivá", "#a4b0c2"],
      ["Modrá", "#4a5a92"],
      ["Zelenkavá", "#71cbc2"],
    ],
    collections: ["letny-typ"],
    accent: "staroružový alebo tlmený modrý",
    reason: "Chladnejšie, tlmené farby nadväzujú na letnú paletu.",
  },
  jesen: {
    title: "Ako prvú vyskúšajte jesennú paletu",
    description:
      "Teplejšie a tlmené odtiene môžu prirodzene doplniť vašu tvár. Skúste terakotu, olivovú či teplejšiu petrolejovú.",
    colors: [
      ["Terakota", "#d06130"],
      ["Olivová", "#69723b"],
      ["Petrolejová", "#39746e"],
      ["Hnedá", "#5a332d"],
      ["Bordová", "#800c0c"],
      ["Krémová", "#e0c49c"],
      ["Kaki", "#cea910"],
    ],
    collections: ["jesenny-typ"],
    accent: "terakotový alebo olivový",
    reason: "Teplé, zemité odtiene nadväzujú na jesennú paletu.",
  },
  zima: {
    title: "Ako prvú vyskúšajte zimnú paletu",
    description:
      "Chladnejšie, čisté farby môžu pri tvári pôsobiť výrazne. Vyskúšajte malinovú, kobaltovú alebo smaragdovú.",
    colors: [
      ["Malinová", "#cf2160"],
      ["Kobaltová", "#0a33a0"],
      ["Smaragdová", "#02877e"],
      ["Námornícka modrá", "#17337d"],
      ["Fialová", "#4b0081"],
      ["Biela", "#ffffff"],
    ],
    collections: ["zimny-typ"],
    accent: "malinový alebo kobaltový",
    reason: "Chladné, jasné odtiene nadväzujú na zimnú paletu.",
  },
  teple_nejasne: {
    title: "Skúste porovnať jarnú a jesennú paletu",
    description:
      "Teplejšie farby sú smerom na skúšanie. Na výber jednej sezóny zatiaľ nemáme dostatok stabilných pozorovaní.",
    colors: [
      ["Koralová", "#df7861"],
      ["Terakota", "#b76646"],
      ["Olivová", "#7c8251"],
      ["Krémová", "#ede0c5"],
      ["Hnedá", "#75533d"],
    ],
    collections: ["jarny-typ", "jesenny-typ"],
    accent: "teplejší",
    reason:
      "Toto sú možnosti na porovnanie teplejších farieb, nie potvrdenie jednej sezóny.",
  },
  chladne_nejasne: {
    title: "Skúste porovnať letnú a zimnú paletu",
    description:
      "Chladnejšie farby sú smerom na skúšanie. Porovnajte tlmenú modrú s čistejšou modrou pri podobnej svetlosti.",
    colors: [
      ["Staroružová", "#c492a5"],
      ["Malinová", "#ba315b"],
      ["Tlmená modrá", "#829cab"],
      ["Mäkká sivá", "#b7b6b8"],
      ["Námornícka", "#263448"],
    ],
    collections: ["letny-typ", "zimny-typ"],
    accent: "chladnejší",
    reason:
      "Toto sú možnosti na porovnanie chladnejších farieb, nie potvrdenie jednej sezóny.",
  },
  neurcene: {
    title: "Začnime tým, čo už máte doma",
    description:
      "Z vašich odpovedí sa nedá vybrať jedna paleta. To je v poriadku. Ukážeme vám, ako skúšať farby a zladiť šatku so svojím oblečením.",
    colors: [],
    collections: ["jarny-typ", "letny-typ", "jesenny-typ", "zimny-typ"],
    accent: "farebný",
    reason:
      "Výber je inšpiráciou k oblečeniu. Vhodnosť farby pri tvári treba ešte vyskúšať.",
  },
};
Object.assign(PALETTES.jar, {
  title: "Vaša farebná stopa smeruje k JARI",
  description:
    "Pravdepodobne vám najviac lichotia svieže, teplejšie a živé farby, ktoré rozžiaria vašu prirodzenú farebnosť.",
});
Object.assign(PALETTES.leto, {
  title: "Vaša farebná stopa smeruje k LETU",
  description:
    "Pravdepodobne vám najviac lichotia jemnejšie, chladnejšie a harmonické odtiene, ktoré dopĺňajú vašu farebnosť bez toho, aby vás prebíjali.",
});
Object.assign(PALETTES.jesen, {
  title: "Vaša farebná stopa smeruje k JESENI",
  description:
    "Pravdepodobne vám najviac lichotia teplé, bohatšie a zemitejšie odtiene, ktoré podporujú prirodzenú hĺbku vašej farebnosti.",
});
Object.assign(PALETTES.zima, {
  title: "Vaša farebná stopa smeruje k ZIME",
  description:
    "Pravdepodobne vám najviac lichotia chladnejšie, sýte a výrazné farby, ktoré podporujú prirodzený kontrast vašej farebnosti.",
});
const activeQuestions = () => QUESTIONS;
const canonicalAnswers = (a = {}) =>
  Object.fromEntries(
    QUESTIONS.filter((q) => a[q.id] !== undefined).map((q) => [q.id, a[q.id]]),
  );
function validateAnswers(a) {
  if (
    !a ||
    typeof a !== "object" ||
    Array.isArray(a) ||
    Object.keys(a).length !== 5 ||
    QUESTIONS.some((q) => !q.options.some((o) => o.value === a[q.id]))
  )
    throw new Error("Odpovedzte na všetkých päť otázok.");
  return a;
}
function chooseSeasons(scores, q3) {
  const ranked = [...SEASONS].sort((a, b) => scores[b] - scores[a]);
  const primaries = ranked.filter((s) => scores[s] === scores[ranked[0]]);
  if (primaries.length > 1)
    return { primary: null, primaries, secondary: null, tied: true };
  const primary = ranked[0];
  const group =
    q3 === "A" ? ["jar", "jesen"] : q3 === "D" ? ["leto", "zima"] : SEASONS;
  const candidates = ranked
    .slice(1)
    .filter(
      (s) =>
        group.includes(primary) &&
        group.includes(s) &&
        scores[primary] - scores[s] <= 2,
    );
  // Unknown temperature or equally plausible secondary palettes give one result.
  const secondary =
    q3 !== "E" &&
    candidates.length &&
    (candidates.length === 1 || scores[candidates[0]] > scores[candidates[1]])
      ? candidates[0]
      : null;
  return { primary, primaries, secondary, tied: false };
}
function resultForSeason(code, secondary = null) {
  const p = PALETTES[code];
  if (!p) throw new Error("Neplatná paleta.");
  const genitive = { jar: "Jari", leto: "Leta", jesen: "Jesene", zima: "Zimy" };
  let secondaryText = secondary
    ? `Vaša farebnosť však pôsobí pomerne neutrálne a môžete krásne fungovať aj v časti palety ${genitive[secondary]}.`
    : null;
  if (code === "jesen" && secondary === "jar")
    secondaryText =
      "Dobre vám môžu fungovať aj niektoré odtiene jarnej palety, najmä tie teplejšie a sýtejšie.";
  if (code === "leto" && secondary === "zima")
    secondaryText =
      "Dobre vám môžu fungovať aj niektoré odtiene zimnej palety, najmä ak sú chladné, ale nie príliš tvrdé.";
  return {
    version: VERSION,
    code,
    source: "quiz",
    ...p,
    status: "single",
    primary_seasons: SEASONS.includes(code) ? [code] : [],
    primary_season: code,
    secondary_season: secondary,
    secondaryText,
    collections: [
      ...p.collections,
      ...(secondary ? PALETTES[secondary].collections : []),
    ],
    productIntro: "Vybrali sme pre vás hodvábne šatky KEYANA z tejto palety.",
    outfits: [
      `K jednofarebnej košeli a džínsom skúste ${p.accent} akcent pri krku.`,
      "K jednoduchému saku pridajte šatku zloženú do úzkeho pásu. Zvyšok doplnkov nechajte jemný.",
    ],
    styling:
      "Šatku zložte do úzkeho pásu alebo prehoďte cez ramená. Otočením vzoru vyskúšajte pri tvári rôzne odtiene.",
    depthTip:
      "Pri vzorovanej šatke záleží na farbe, ktorá po uviazaní zostane pri tvári.",
    caveat: "Online kvíz je orientačný a nenahrádza osobnú farebnú analýzu.",
    experiment:
      "Pri nepriamom dennom svetle porovnajte dve jednofarebné látky pri tvári. Všímajte si sviežosť tváre a rovnomernosť pleti, nie to, ktorá farba sa vám viac páči.",
  };
}
function resultForTie(seasons) {
  if (
    !Array.isArray(seasons) ||
    seasons.length < 2 ||
    seasons.length > 4 ||
    new Set(seasons).size !== seasons.length ||
    seasons.some((s) => !SEASONS.includes(s))
  )
    throw new Error("Neplatné palety pri remíze.");
  const primaries = SEASONS.filter((s) => seasons.includes(s));
  const count =
    primaries.length === 2
      ? "dvom"
      : primaries.length === 3
        ? "trom"
        : "štyrom";
  return {
    ...resultForSeason("neurcene"),
    code: "ambiguous",
    status: "ambiguous",
    primary_season: null,
    primary_seasons: primaries,
    secondary_season: null,
    tied: true,
    title: `Vaša farebná stopa smeruje k ${count} paletám`,
    description: `Vaše odpovede smerujú k ${count} farebným paletám. Online kvíz ich nedokáže spoľahlivo odlíšiť. Presnejší výsledok získate osobnou analýzou. Palety na porovnanie: ${primaries.map((s) => SEASON_NAMES[s]).join(" / ")}.`,
    collections: primaries.flatMap((s) => PALETTES[s].collections),
    productIntro: "Porovnajte hodvábne šatky KEYANA z týchto paliet.",
    reason: "Paleta na porovnanie pri nerozhodnom výsledku kvízu.",
  };
}
function evaluate(input) {
  const a = validateAnswers(input),
    scores = Object.fromEntries(SEASONS.map((s) => [s, 0]));
  const rows = QUESTIONS.map(
    (q) => q.options.find((o) => o.value === a[q.id]).points,
  );
  rows.forEach((row) => row.forEach((v, i) => (scores[SEASONS[i]] += v)));
  const { primary, primaries, secondary, tied } = chooseSeasons(scores, a.q3);
  return {
    ...(tied ? resultForTie(primaries) : resultForSeason(primary, secondary)),
    scores,
    tied,
    depthTip:
      a.q4 === "A"
        ? "Pri tvári skúste svetlejšiu časť vzoru."
        : a.q4 === "C"
          ? "Pri tvári skúste tmavšiu časť vzoru."
          : "Pri vzorovanej šatke záleží na farbe, ktorá po uviazaní zostane pri tvári.",
  };
}
function reviewAnswers(code) {
  return (
    {
      jar: { q1: "A", q2: "B", q3: "A", q4: "A", q5: "C" },
      leto: { q1: "B", q2: "A", q3: "D", q4: "A", q5: "A" },
      jesen: { q1: "C", q2: "D", q3: "A", q4: "C", q5: "A" },
      zima: { q1: "D", q2: "E", q3: "D", q4: "C", q5: "C" },
    }[code] || { q1: "B", q2: "A", q3: "E", q4: "D", q5: "D" }
  );
}

// Canonical Slovak strings are lookup keys. EN and CS are translated directly from those keys.
const COPY = {
  "V e-mailovej adrese môže byť preklep. Skontrolujte doménu za znakom @.": {
    en: "There may be a typo in your email address. Check the domain after @.",
    cs: "V e-mailové adrese může být překlep. Zkontrolujte doménu za znakem @.",
  },
  "Použiť doménu": {
    en: "Use domain",
    cs: "Použít doménu",
  },
  "Ponechať zadanú adresu": {
    en: "Keep the address I entered",
    cs: "Ponechat zadanou adresu",
  },
  Jar: {
    en: "Spring",
    cs: "Jaro",
  },
  Leto: {
    en: "Summer",
    cs: "Léto",
  },
  Jeseň: {
    en: "Autumn",
    cs: "Podzim",
  },
  Zima: {
    en: "Winter",
    cs: "Zima",
  },
  "Aká je vaša prirodzená farba vlasov?": {
    en: "What is your natural hair colour?",
    cs: "Jaká je Vaše přirozená barva vlasů?",
  },
  "Vyberte farbu bez farbenia alebo melíru.": {
    en: "Choose your colour without dye or highlights.",
    cs: "Vyberte barvu bez barvení nebo melíru.",
  },
  "Svetlá blond až svetlohnedá so zlatistým alebo medovým nádychom": {
    en: "Light blonde to light brown with golden or honey tones",
    cs: "Světlá blond až světle hnědá se zlatavým nebo medovým nádechem",
  },
  "Popolavá blond až svetlá alebo stredná popolavohnedá": {
    en: "Ash blonde to light or medium ash brown",
    cs: "Popelavá blond až světlá nebo střední popelavě hnědá",
  },
  "Medená, gaštanová, zlatohnedá alebo teplá hnedá": {
    en: "Copper, chestnut, golden brown or warm brown",
    cs: "Měděná, kaštanová, zlatohnědá nebo teplá hnědá",
  },
  "Tmavohnedá až čierna": {
    en: "Dark brown to black",
    cs: "Tmavě hnědá až černá",
  },
  "Ako by ste najlepšie opísali svoje oči?": {
    en: "How would you best describe your eyes?",
    cs: "Jak byste nejlépe popsala své oči?",
  },
  "Svetlé a jemné – sivé, sivomodré, jemné zelené": {
    en: "Light and soft – grey, blue-grey, soft green",
    cs: "Světlé a jemné – šedé, šedomodré, jemně zelené",
  },
  "Jasné a výrazné – jasnomodré, výrazne zelené, tyrkysové": {
    en: "Clear and striking – bright blue, vivid green, turquoise",
    cs: "Jasné a výrazné – jasně modré, výrazně zelené, tyrkysové",
  },
  "Zelené, zeleno-sivé, modrozelené alebo viacfarebné": {
    en: "Green, green-grey, blue-green or multicoloured",
    cs: "Zelené, zelenošedé, modrozelené nebo vícebarevné",
  },
  "Orieškové, olivové, jantárové alebo teplé hnedé": {
    en: "Hazel, olive, amber or warm brown",
    cs: "Oříškové, olivové, jantarové nebo teplé hnědé",
  },
  "Tmavohnedé až veľmi tmavé": {
    en: "Dark brown to very dark",
    cs: "Tmavě hnědé až velmi tmavé",
  },
  "Ktoré farby vám pri tvári pristanú viac?": {
    en: "Which colours suit you better next to your face?",
    cs: "Které barvy Vám u obličeje sluší více?",
  },
  "Porovnajte farebné palety podľa toho, ako pôsobia pri vašej tvári.": {
    en: "Compare the colour palettes by how they look next to your face.",
    cs: "Porovnejte barevné palety podle toho, jak působí u Vašeho obličeje.",
  },
  "Teplejšie – napr. koralová, marhuľová, teplá zelená": {
    en: "Warmer – for example coral, apricot, warm green",
    cs: "Teplejší – např. korálová, meruňková, teplá zelená",
  },
  "Skôr teplejšie, ale dobre nosím aj chladnejšie farby": {
    en: "Mostly warmer, but cooler colours also suit me",
    cs: "Spíše teplejší, ale sluší mi i chladnější barvy",
  },
  "Skôr chladnejšie, ale dobre nosím aj teplejšie farby": {
    en: "Mostly cooler, but warmer colours also suit me",
    cs: "Spíše chladnější, ale sluší mi i teplejší barvy",
  },
  "Chladnejšie – napr. malinová, levanduľová, chladná modrá": {
    en: "Cooler – for example raspberry, lavender, cool blue",
    cs: "Chladnější – např. malinová, levandulová, chladná modrá",
  },
  "Neviem posúdiť": {
    en: "I cannot tell",
    cs: "Nedokážu posoudit",
  },
  "Pristanú vám viac svetlejšie alebo tmavšie farby?": {
    en: "Do lighter or darker colours suit you better?",
    cs: "Sluší Vám více světlejší, nebo tmavší barvy?",
  },
  "Myslite iba na to, ako svetlá alebo tmavá je farba – nie na to, či je jemná alebo výrazná.":
    {
      en: "Focus only on how light or dark a colour is, rather than whether it is soft or vivid.",
      cs: "Zaměřte se pouze na to, jak je barva světlá nebo tmavá – nikoli na to, zda je jemná nebo výrazná.",
    },
  "Skôr svetlejšie – veľmi tmavé farby ma často zatienia": {
    en: "Mostly lighter – very dark colours often overpower me",
    cs: "Spíše světlejší – velmi tmavé barvy mě často zastíní",
  },
  "Niečo medzi – najlepšie mi pristanú stredne svetlé až stredne tmavé farby": {
    en: "Somewhere in between – medium-light to medium-dark colours suit me best",
    cs: "Něco mezi – nejlépe mi sluší středně světlé až středně tmavé barvy",
  },
  "Skôr tmavšie – svetlé farby pri mne často pôsobia príliš slabo": {
    en: "Mostly darker – light colours often look too weak on me",
    cs: "Spíše tmavší – světlé barvy na mně často působí příliš slabě",
  },
  "Pristanú vám viac jemné alebo sýte farby?": {
    en: "Do soft or saturated colours suit you better?",
    cs: "Sluší Vám více jemné, nebo syté barvy?",
  },
  "Teraz nejde o svetlosť. Všímajte si, či farby pôsobia tlmene alebo žiarivo.":
    {
      en: "This time, ignore lightness. Notice whether the colours look muted or bright.",
      cs: "Nyní nejde o světlost. Všímejte si, zda barvy působí tlumeně, nebo zářivě.",
    },
  "Jemné a tlmené – výrazné farby ma často prebijú": {
    en: "Soft and muted – vivid colours often overpower me",
    cs: "Jemné a tlumené – výrazné barvy mě často přehluší",
  },
  "Niečo medzi – ani veľmi tlmené, ani veľmi sýte": {
    en: "Somewhere in between – neither very muted nor very saturated",
    cs: "Něco mezi – ani velmi tlumené, ani velmi syté",
  },
  "Sýte a žiarivé – výrazné farby ma neprebíjajú, moja tvár pri nich vynikne": {
    en: "Saturated and bright – vivid colours do not overpower me; they make my face stand out",
    cs: "Syté a zářivé – výrazné barvy mě nepřebíjejí, můj obličej při nich vynikne",
  },
  "Chcem aj dva tipy a mesačné novinky Keyany e-mailom. Odber je dobrovoľný, odhlásiť sa môžem kedykoľvek.":
    {
      en: "I would also like two tips and Keyana’s monthly news by email. Subscribing is optional, and I can unsubscribe at any time.",
      cs: "Chci také dva tipy a měsíční novinky Keyany e-mailem. Odběr je dobrovolný, odhlásit se mohu kdykoli.",
    },
  "Od orientačného výsledku k Vašim osobným farbám": {
    en: "From an indicative result to your personal colours",
    cs: "Od orientačního výsledku k Vašim osobním barvám",
  },
  "Kvíz je prvý krok. Pri osobnej konzultácii s Jankou Keketi, imidžovou poradkyňou a zakladateľkou KEYANA, spresníte svoju farebnú sezónu aj zaradenie do jedného z 12 podtypov.":
    {
      en: "The quiz is a first step. A personal consultation with Janka Keketi, image consultant and founder of KEYANA, will refine your colour season and identify which of the 12 subtypes suits you.",
      cs: "Kvíz je první krok. Při osobní konzultaci s Jankou Keketi, image poradkyní a zakladatelkou KEYANA, upřesníte svou barevnou sezónu i zařazení do jednoho z 12 podtypů.",
    },
  "Získate odporúčania na odtiene oblečenia, líčenia a vlasov. Janka Vám pomôže aj s výberom hodvábnej šatky, ktorej farby vyniknú pri Vašej tvári.":
    {
      en: "You will receive recommendations for clothing, make-up and hair colours. Janka will also help you choose a silk scarf whose colours complement your face.",
      cs: "Získáte doporučení pro odstíny oblečení, líčení a vlasů. Janka Vám také pomůže vybrat hedvábný šátek, jehož barvy vyniknou u Vašeho obličeje.",
    },
  "Dohodnúť konzultáciu s Jankou": {
    en: "Arrange a consultation with Janka",
    cs: "Domluvit konzultaci s Jankou",
  },
  "Vo formulári napíšte, že máte záujem o osobnú farebnú typológiu. Termín si dohodnete priamo s Jankou.":
    {
      en: "In the form, mention that you are interested in a personal colour analysis. You will arrange the appointment directly with Janka.",
      cs: "Do formuláře napište, že máte zájem o osobní barevnou typologii. Termín si domluvíte přímo s Jankou.",
    },
  "Vaša farebná stopa smeruje k JARI": {
    en: "Your colour profile points towards SPRING",
    cs: "Vaše barevná stopa směřuje k JARU",
  },
  "Vaša farebná stopa smeruje k LETU": {
    en: "Your colour profile points towards SUMMER",
    cs: "Vaše barevná stopa směřuje k LÉTU",
  },
  "Vaša farebná stopa smeruje k JESENI": {
    en: "Your colour profile points towards AUTUMN",
    cs: "Vaše barevná stopa směřuje k PODZIMU",
  },
  "Vaša farebná stopa smeruje k ZIME": {
    en: "Your colour profile points towards WINTER",
    cs: "Vaše barevná stopa směřuje k ZIMĚ",
  },
  "Pravdepodobne vám najviac lichotia svieže, teplejšie a živé farby, ktoré rozžiaria vašu prirodzenú farebnosť.":
    {
      en: "Fresh, warmer and lively colours are likely to flatter you most and brighten your natural colouring.",
      cs: "Pravděpodobně Vám nejvíce lichotí svěží, teplejší a živé barvy, které rozzáří Vaši přirozenou barevnost.",
    },
  "Pravdepodobne vám najviac lichotia jemnejšie, chladnejšie a harmonické odtiene, ktoré dopĺňajú vašu farebnosť bez toho, aby vás prebíjali.":
    {
      en: "Softer, cooler and harmonious shades are likely to flatter you most, complementing your colouring without overpowering it.",
      cs: "Pravděpodobně Vám nejvíce lichotí jemnější, chladnější a harmonické odstíny, které doplňují Vaši barevnost, aniž by Vás přebíjely.",
    },
  "Pravdepodobne vám najviac lichotia teplé, bohatšie a zemitejšie odtiene, ktoré podporujú prirodzenú hĺbku vašej farebnosti.":
    {
      en: "Warm, richer and earthier shades are likely to flatter you most, supporting the natural depth of your colouring.",
      cs: "Pravděpodobně Vám nejvíce lichotí teplé, bohatší a zemitější odstíny, které podpoří přirozenou hloubku Vaší barevnosti.",
    },
  "Pravdepodobne vám najviac lichotia chladnejšie, sýte a výrazné farby, ktoré podporujú prirodzený kontrast vašej farebnosti.":
    {
      en: "Cooler, saturated and striking colours are likely to flatter you most, supporting the natural contrast of your colouring.",
      cs: "Pravděpodobně Vám nejvíce lichotí chladnější, syté a výrazné barvy, které podpoří přirozený kontrast Vaší barevnosti.",
    },
  Koralová: {
    en: "Coral",
    cs: "Korálová",
  },
  Tyrkysová: {
    en: "Turquoise",
    cs: "Tyrkysová",
  },
  Marhuľková: {
    en: "Apricot",
    cs: "Meruňková",
  },
  Krémová: {
    en: "Cream",
    cs: "Krémová",
  },
  Žltá: {
    en: "Yellow",
    cs: "Žlutá",
  },
  Béžová: {
    en: "Beige",
    cs: "Béžová",
  },
  Ružová: {
    en: "Pink",
    cs: "Růžová",
  },
  Levanduľová: {
    en: "Lavender",
    cs: "Levandulová",
  },
  "Pastelová modrá": {
    en: "Pastel blue",
    cs: "Pastelově modrá",
  },
  "Bledo sivá": {
    en: "Pale grey",
    cs: "Světle šedá",
  },
  Modrá: {
    en: "Blue",
    cs: "Modrá",
  },
  Zelenkavá: {
    en: "Soft green",
    cs: "Zelenkavá",
  },
  Terakota: {
    en: "Terracotta",
    cs: "Terakota",
  },
  Olivová: {
    en: "Olive",
    cs: "Olivová",
  },
  Petrolejová: {
    en: "Teal",
    cs: "Petrolejová",
  },
  Hnedá: {
    en: "Brown",
    cs: "Hnědá",
  },
  Bordová: {
    en: "Burgundy",
    cs: "Vínová",
  },
  Kaki: {
    en: "Khaki",
    cs: "Khaki",
  },
  Malinová: {
    en: "Raspberry",
    cs: "Malinová",
  },
  Kobaltová: {
    en: "Cobalt",
    cs: "Kobaltová",
  },
  Smaragdová: {
    en: "Emerald",
    cs: "Smaragdová",
  },
  "Námornícka modrá": {
    en: "Navy blue",
    cs: "Námořnická modrá",
  },
  Fialová: {
    en: "Purple",
    cs: "Fialová",
  },
  Biela: {
    en: "White",
    cs: "Bílá",
  },
  Staroružová: {
    en: "Dusty rose",
    cs: "Starorůžová",
  },
  "Tlmená modrá": {
    en: "Muted blue",
    cs: "Tlumená modrá",
  },
  "Mäkká sivá": {
    en: "Soft grey",
    cs: "Jemná šedá",
  },
  Námornícka: {
    en: "Navy",
    cs: "Námořnická",
  },
  "koralový alebo teplejší tyrkysový": {
    en: "coral or warmer turquoise",
    cs: "korálový nebo teplejší tyrkysový",
  },
  "staroružový alebo tlmený modrý": {
    en: "dusty rose or muted blue",
    cs: "starorůžový nebo tlumený modrý",
  },
  "terakotový alebo olivový": {
    en: "terracotta or olive",
    cs: "terakotový nebo olivový",
  },
  "malinový alebo kobaltový": {
    en: "raspberry or cobalt",
    cs: "malinový nebo kobaltový",
  },
  teplejší: {
    en: "warmer",
    cs: "teplejší",
  },
  chladnejší: {
    en: "cooler",
    cs: "chladnější",
  },
  farebný: {
    en: "colourful",
    cs: "barevný",
  },
  "Teplejšie, jasnejšie farby nadväzujú na jarnú paletu.": {
    en: "Warmer, clearer colours reflect the spring palette.",
    cs: "Teplejší, jasnější barvy navazují na jarní paletu.",
  },
  "Chladnejšie, tlmené farby nadväzujú na letnú paletu.": {
    en: "Cooler, muted colours reflect the summer palette.",
    cs: "Chladnější, tlumené barvy navazují na letní paletu.",
  },
  "Teplé, zemité odtiene nadväzujú na jesennú paletu.": {
    en: "Warm, earthy shades reflect the autumn palette.",
    cs: "Teplé, zemité odstíny navazují na podzimní paletu.",
  },
  "Chladné, jasné odtiene nadväzujú na zimnú paletu.": {
    en: "Cool, clear shades reflect the winter palette.",
    cs: "Chladné, jasné odstíny navazují na zimní paletu.",
  },
  "Dobre vám môžu fungovať aj niektoré odtiene jarnej palety, najmä tie teplejšie a sýtejšie.":
    {
      en: "Some shades from the spring palette may also work well for you, especially warmer and more saturated ones.",
      cs: "Dobře Vám mohou slušet i některé odstíny jarní palety, zejména ty teplejší a sytější.",
    },
  "Dobre vám môžu fungovať aj niektoré odtiene zimnej palety, najmä ak sú chladné, ale nie príliš tvrdé.":
    {
      en: "Some shades from the winter palette may also work well for you, especially if they are cool but not too harsh.",
      cs: "Dobře Vám mohou slušet i některé odstíny zimní palety, zejména pokud jsou chladné, ale ne příliš ostré.",
    },
  "Vybrali sme pre vás hodvábne šatky KEYANA z tejto palety.": {
    en: "We have selected KEYANA silk scarves from this palette for you.",
    cs: "Vybrali jsme pro Vás hedvábné šátky KEYANA z této palety.",
  },
  "K jednoduchému saku pridajte šatku zloženú do úzkeho pásu. Zvyšok doplnkov nechajte jemný.":
    {
      en: "Add a scarf folded into a narrow band to a simple blazer. Keep your other accessories understated.",
      cs: "K jednoduchému saku přidejte šátek složený do úzkého pruhu. Ostatní doplňky nechte jemné.",
    },
  "Šatku zložte do úzkeho pásu alebo prehoďte cez ramená. Otočením vzoru vyskúšajte pri tvári rôzne odtiene.":
    {
      en: "Fold the scarf into a narrow band or drape it over your shoulders. Turn the pattern to try different shades next to your face.",
      cs: "Šátek složte do úzkého pruhu nebo přehoďte přes ramena. Otáčením vzoru vyzkoušejte u obličeje různé odstíny.",
    },
  "Pri vzorovanej šatke záleží na farbe, ktorá po uviazaní zostane pri tvári.":
    {
      en: "With a patterned scarf, what matters is the colour that remains next to your face after tying it.",
      cs: "U vzorovaného šátku záleží na barvě, která po uvázání zůstane u obličeje.",
    },
  "Online kvíz je orientačný a nenahrádza osobnú farebnú analýzu.": {
    en: "The online quiz is indicative and does not replace a personal colour analysis.",
    cs: "Online kvíz je orientační a nenahrazuje osobní barevnou analýzu.",
  },
  "Pri nepriamom dennom svetle porovnajte dve jednofarebné látky pri tvári. Všímajte si sviežosť tváre a rovnomernosť pleti, nie to, ktorá farba sa vám viac páči.":
    {
      en: "In indirect daylight, compare two plain fabrics next to your face. Notice how fresh your face looks and how even your skin appears, rather than which colour you prefer.",
      cs: "Při nepřímém denním světle porovnejte u obličeje dvě jednobarevné látky. Všímejte si svěžesti obličeje a rovnoměrnosti pleti, nikoli toho, která barva se Vám více líbí.",
    },
  "Pri tvári skúste svetlejšiu časť vzoru.": {
    en: "Try the lighter part of the pattern next to your face.",
    cs: "U obličeje vyzkoušejte světlejší část vzoru.",
  },
  "Pri tvári skúste tmavšiu časť vzoru.": {
    en: "Try the darker part of the pattern next to your face.",
    cs: "U obličeje vyzkoušejte tmavší část vzoru.",
  },
  "Porovnajte hodvábne šatky KEYANA z týchto paliet.": {
    en: "Compare KEYANA silk scarves from these palettes.",
    cs: "Porovnejte hedvábné šátky KEYANA z těchto palet.",
  },
  "Paleta na porovnanie pri nerozhodnom výsledku kvízu.": {
    en: "A palette to compare when the quiz result is tied.",
    cs: "Paleta k porovnání při nerozhodném výsledku kvízu.",
  },
  "Odpovedzte na všetkých päť otázok.": {
    en: "Answer all five questions.",
    cs: "Odpovězte na všech pět otázek.",
  },
  "Neplatná paleta.": {
    en: "Invalid palette.",
    cs: "Neplatná paleta.",
  },
  "Neplatné palety pri remíze.": {
    en: "Invalid palettes for a tied result.",
    cs: "Neplatné palety při remíze.",
  },
  "Začnime tým, čo už máte doma": {
    en: "Let us start with what you already own",
    cs: "Začněme tím, co už máte doma",
  },
  "Z vašich odpovedí sa nedá vybrať jedna paleta. To je v poriadku. Ukážeme vám, ako skúšať farby a zladiť šatku so svojím oblečením.":
    {
      en: "Your answers do not point to a single palette. That is fine. We will show you how to try colours and match a scarf with your clothes.",
      cs: "Z Vašich odpovědí nelze vybrat jednu paletu. To je v pořádku. Ukážeme Vám, jak zkoušet barvy a sladit šátek se svým oblečením.",
    },
  "Výber je inšpiráciou k oblečeniu. Vhodnosť farby pri tvári treba ešte vyskúšať.":
    {
      en: "This selection is outfit inspiration. You still need to try the colour next to your face.",
      cs: "Výběr je inspirací k oblečení. Vhodnost barvy u obličeje je třeba ještě vyzkoušet.",
    },
  "BETA NA PRIPOMIENKOVANIE": {
    en: "BETA FOR REVIEW",
    cs: "BETA K PŘIPOMÍNKÁM",
  },
  "Päť otázok a bodovanie podľa Janky · V1.1": {
    en: "Five questions and scoring by Janka · V1.1",
    cs: "Pět otázek a bodování podle Janky · V1.1",
  },
  "Lokálna ukážka — e-maily sa neodosielajú.": {
    en: "Local preview — no emails are sent.",
    cs: "Lokální ukázka — e-maily se neodesílají.",
  },
  "Opätovne potvrdiť odber ↗": {
    en: "Reconfirm your subscription ↗",
    cs: "Znovu potvrdit odběr ↗",
  },
  "UKÁŽKA VÝSLEDKU": {
    en: "RESULT PREVIEW",
    cs: "UKÁZKA VÝSLEDKU",
  },
  "VAŠA FAREBNÁ PALETA": {
    en: "YOUR COLOUR PALETTE",
    cs: "VAŠE BAREVNÁ PALETA",
  },
  "HODVÁB VO VAŠICH FARBÁCH": {
    en: "SILK IN YOUR COLOURS",
    cs: "HEDVÁBÍ VE VAŠICH BARVÁCH",
  },
  "Šatky vybrané pre vás": {
    en: "Scarves selected for you",
    cs: "Šátky vybrané pro Vás",
  },
  "Načítavame aktuálny výber…": {
    en: "Loading the current selection…",
    cs: "Načítáme aktuální výběr…",
  },
  "Pozrieť jarnú kolekciu ↗": {
    en: "View the spring collection ↗",
    cs: "Prohlédnout jarní kolekci ↗",
  },
  "Pozrieť letnú kolekciu ↗": {
    en: "View the summer collection ↗",
    cs: "Prohlédnout letní kolekci ↗",
  },
  "Pozrieť jesennú kolekciu ↗": {
    en: "View the autumn collection ↗",
    cs: "Prohlédnout podzimní kolekci ↗",
  },
  "Pozrieť zimnú kolekciu ↗": {
    en: "View the winter collection ↗",
    cs: "Prohlédnout zimní kolekci ↗",
  },
  "Pozrieť šatky v mojich farbách ↗": {
    en: "View scarves in my colours ↗",
    cs: "Prohlédnout šátky v mých barvách ↗",
  },
  "Ako farby nosiť a vyskúšať doma": {
    en: "How to wear and try colours at home",
    cs: "Jak barvy nosit a vyzkoušet doma",
  },
  "Pozrieť šatku ↗": {
    en: "View scarf ↗",
    cs: "Prohlédnout šátek ↗",
  },
  "Aktuálny výber nájdete v kolekciách nižšie.": {
    en: "Find the current selection in the collections below.",
    cs: "Aktuální výběr najdete v kolekcích níže.",
  },
  "Výber sa teraz nenačítal. Šatky nájdete v kolekciách nižšie.": {
    en: "The selection could not be loaded. Find scarves in the collections below.",
    cs: "Výběr se nyní nenačetl. Šátky najdete v kolekcích níže.",
  },
  "FAREBNÝ KVÍZ KEYANA": {
    en: "KEYANA COLOUR QUIZ",
    cs: "BAREVNÝ KVÍZ KEYANA",
  },
  "Objavte farby, ktoré vám pristanú": {
    en: "Discover the colours that suit you",
    cs: "Objevte barvy, které Vám sluší",
  },
  "Odpovedzte na": {
    en: "Answer",
    cs: "Odpovězte na",
  },
  "5 krátkych otázok": {
    en: "5 short questions",
    cs: "5 krátkých otázek",
  },
  "a zistite, ku ktorej farebnej palete máte najbližšie.": {
    en: "and find out which colour palette is closest to yours.",
    cs: "a zjistěte, ke které barevné paletě máte nejblíže.",
  },
  "Nejde o farby, ktoré máte najradšej. Myslite na farby,": {
    en: "This is not about your favourite colours. Think of the colours",
    cs: "Nejde o barvy, které máte nejraději. Myslete na barvy,",
  },
  "pri ktorých vaša tvár vyzerá sviežo a pleť rovnomernejšie.": {
    en: "that make your face look fresh and your skin appear more even.",
    cs: "při kterých Váš obličej vypadá svěže a pleť rovnoměrněji.",
  },
  "Objaviť moju paletu": {
    en: "Discover my palette",
    cs: "Objevit mou paletu",
  },
  "01 / VAŠA PRIRODZENÁ FAREBNOSŤ": {
    en: "01 / YOUR NATURAL COLOURING",
    cs: "01 / VAŠE PŘIROZENÁ BAREVNOST",
  },
  "Začneme prirodzenou farbou vlasov a očí.": {
    en: "We will start with your natural hair and eye colour.",
    cs: "Začneme přirozenou barvou vlasů a očí.",
  },
  "02 / FARBY PRI TVÁRI": {
    en: "02 / COLOURS NEXT TO YOUR FACE",
    cs: "02 / BARVY U OBLIČEJE",
  },
  "Farebné ukážky vám pomôžu porovnať odtiene. Myslite na svoju tvár, nie na obľúbenú farbu.":
    {
      en: "The colour samples help you compare shades. Think about your face, rather than your favourite colour.",
      cs: "Barevné ukázky Vám pomohou porovnat odstíny. Myslete na svůj obličej, nikoli na oblíbenou barvu.",
    },
  "03 / VAŠA PALETA": {
    en: "03 / YOUR PALETTE",
    cs: "03 / VAŠE PALETA",
  },
  "E-mailom získate orientačný výsledok a výber hodvábnych šatiek KEYANA. Kvíz nenahrádza osobnú farebnú analýzu.":
    {
      en: "You will receive an indicative result and a selection of KEYANA silk scarves by email. The quiz does not replace a personal colour analysis.",
      cs: "E-mailem získáte orientační výsledek a výběr hedvábných šátků KEYANA. Kvíz nenahrazuje osobní barevnou analýzu.",
    },
  "Postup dotazníka": {
    en: "Quiz progress",
    cs: "Průběh dotazníku",
  },
  "← Späť": {
    en: "← Back",
    cs: "← Zpět",
  },
  "Pokračovať →": {
    en: "Continue →",
    cs: "Pokračovat →",
  },
  "Vyberte jednu možnosť. Vrátiť sa môžete kedykoľvek.": {
    en: "Choose one option. You can go back at any time.",
    cs: "Vyberte jednu možnost. Vrátit se můžete kdykoli.",
  },
  "Vyberte jednu možnosť.": {
    en: "Choose one option.",
    cs: "Vyberte jednu možnost.",
  },
  "5 / 5 · HOTOVO": {
    en: "5 / 5 · COMPLETE",
    cs: "5 / 5 · HOTOVO",
  },
  "Vašu farebnú paletu pripravujeme": {
    en: "We are preparing your colour palette",
    cs: "Připravujeme Vaši barevnou paletu",
  },
  "Zadajte svoj e-mail. Pošleme Vám orientačný výsledok, tipy na nosenie farieb a výber hodvábnych šatiek KEYANA, vo farbách, ktoré by Vám mohli pristať. Odber noviniek je dobrovoľný.":
    {
      en: "Enter your email address. We will send you an indicative result, tips for wearing colours and a selection of KEYANA silk scarves in colours that may suit you. Subscribing to news is optional.",
      cs: "Zadejte svůj e-mail. Pošleme Vám orientační výsledek, tipy na nošení barev a výběr hedvábných šátků KEYANA v barvách, které by Vám mohly slušet. Odběr novinek je dobrovolný.",
    },
  "Váš e-mail": {
    en: "Your email",
    cs: "Váš e-mail",
  },
  "vas@email.sk": {
    en: "you@example.com",
    cs: "vas@email.cz",
  },
  Web: {
    en: "Website",
    cs: "Web",
  },
  "Ochrana osobných údajov": {
    en: "Privacy Policy",
    cs: "Ochrana osobních údajů",
  },
  "Poslať moju farebnú paletu →": {
    en: "Send my colour palette →",
    cs: "Poslat mou barevnou paletu →",
  },
  "← Späť k otázkam": {
    en: "← Back to the questions",
    cs: "← Zpět k otázkám",
  },
  "Pripravujeme váš výsledok…": {
    en: "Preparing your result…",
    cs: "Připravujeme Váš výsledek…",
  },
  "Lokálna ukážka. Údaje zostali v lokálnej bete; žiadny e-mail ani odber nevznikol.":
    {
      en: "Local preview. The data stayed in the local beta; no email or subscription was created.",
      cs: "Lokální ukázka. Údaje zůstaly v lokální betě; žádný e-mail ani odběr nevznikl.",
    },
  "Vaša farebná paleta je na ceste": {
    en: "Your colour palette is on its way",
    cs: "Vaše barevná paleta je na cestě",
  },
  "E-mail pripravujeme na odoslanie. Nájdete v ňom svoju paletu, tipy na nosenie farieb aj vybrané šatky KEYANA.":
    {
      en: "We are preparing your email. It will contain your palette, tips for wearing colours and selected KEYANA scarves.",
      cs: "Připravujeme e-mail k odeslání. Najdete v něm svou paletu, tipy na nošení barev i vybrané šátky KEYANA.",
    },
  "E-mail práve odosielame. O chvíľu si skontrolujte doručenú poštu.": {
    en: "We are sending your email now. Check your inbox shortly.",
    cs: "E-mail právě odesíláme. Za chvíli si zkontrolujte doručenou poštu.",
  },
  "Vašu farebnú paletu sme odoslali": {
    en: "We have sent your colour palette",
    cs: "Odeslali jsme Vaši barevnou paletu",
  },
  "Skontrolujte si e-mail vrátane priečinkov Reklamy a Spam. Potvrdenie doručenia ešte čakáme.":
    {
      en: "Check your inbox, including Promotions and Spam. We are still waiting for delivery confirmation.",
      cs: "Zkontrolujte si e-mail včetně složek Hromadné a Spam. Na potvrzení doručení ještě čekáme.",
    },
  "Vaša farebná paleta je v e-maile": {
    en: "Your colour palette is in your email",
    cs: "Vaše barevná paleta je v e-mailu",
  },
  "Poštový server potvrdil doručenie. Ak správu nevidíte, pozrite aj priečinky Reklamy a Spam.":
    {
      en: "The mail server has confirmed delivery. If you cannot see the message, check Promotions and Spam too.",
      cs: "Poštovní server potvrdil doručení. Pokud zprávu nevidíte, podívejte se také do složek Hromadné a Spam.",
    },
  "Overujeme odoslanie e-mailu": {
    en: "We are checking the email delivery",
    cs: "Ověřujeme odeslání e-mailu",
  },
  "Odoslanie zatiaľ nevieme potvrdiť. Skontrolujte si schránku; ďalšiu správu teraz neposielame, aby Vám neprišla dvakrát.":
    {
      en: "We cannot confirm sending yet. Check your inbox; we are not sending another message now, to avoid sending it twice.",
      cs: "Odeslání zatím nemůžeme potvrdit. Zkontrolujte si schránku; další zprávu nyní neposíláme, aby Vám nepřišla dvakrát.",
    },
  "E-mail sa nepodarilo doručiť": {
    en: "The email could not be delivered",
    cs: "E-mail se nepodařilo doručit",
  },
  "Ak je opätovné odoslanie dostupné, skúste ho nižšie. Pri pretrvávajúcom probléme nás kontaktujte na jana@keyana.sk.":
    {
      en: "If resending is available, try it below. If the problem persists, contact jana@keyana.sk.",
      cs: "Pokud je opětovné odeslání dostupné, zkuste ho níže. Pokud problém přetrvává, kontaktujte nás na jana@keyana.sk.",
    },
  "E-mail na túto adresu nemôžeme odoslať": {
    en: "We cannot send email to this address",
    cs: "Na tuto adresu nemůžeme odeslat e-mail",
  },
  "Doručovanie na túto adresu bolo pozastavené. Kontaktujte nás na jana@keyana.sk.":
    {
      en: "Delivery to this address has been suspended. Contact jana@keyana.sk.",
      cs: "Doručování na tuto adresu bylo pozastaveno. Kontaktujte nás na jana@keyana.sk.",
    },
  "Odoslanie e-mailu bolo zastavené": {
    en: "Email sending was stopped",
    cs: "Odesílání e-mailu bylo zastaveno",
  },
  "Ak si chcete vyžiadať výsledok, použite formulár nižšie alebo nás kontaktujte na jana@keyana.sk.":
    {
      en: "To request your result, use the form below or contact jana@keyana.sk.",
      cs: "Pokud si chcete vyžádat výsledek, použijte formulář níže nebo nás kontaktujte na jana@keyana.sk.",
    },
  "Vaša farebná paleta patrí do e-mailu": {
    en: "Your colour palette belongs in your email",
    cs: "Vaše barevná paleta patří do e-mailu",
  },
  "Výsledky už zobrazujeme iba v e-maile. Ak ste svoj výsledok ešte nedostali, vyžiadajte si ho na pôvodnú adresu nižšie.":
    {
      en: "Results are now shown only in email. If you have not received yours yet, request it below using your original address.",
      cs: "Výsledky již zobrazujeme pouze v e-mailu. Pokud jste svůj výsledek ještě nedostala, vyžádejte si ho níže na původní adresu.",
    },
  "Vašu požiadavku evidujeme": {
    en: "We have recorded your request",
    cs: "Vaši žádost evidujeme",
  },
  "Stav odoslania si môžete overiť obnovením stránky.": {
    en: "Refresh the page to check the sending status.",
    cs: "Stav odeslání si můžete ověřit obnovením stránky.",
  },
  "Ukážka potvrdenia": {
    en: "Confirmation preview",
    cs: "Ukázka potvrzení",
  },
  "Lokálna ukážka neposiela e-maily. Výsledky a e-maily nájdete v prehľade pre Janku.":
    {
      en: "The local preview does not send emails. Find the results and emails in the review for Janka.",
      cs: "Lokální ukázka neposílá e-maily. Výsledky a e-maily najdete v přehledu pro Janku.",
    },
  "Vašu požiadavku sme uložili": {
    en: "We have saved your request",
    cs: "Vaši žádost jsme uložili",
  },
  "Odosielanie e-mailov je dočasne pozastavené. Stav si môžete overiť neskôr.":
    {
      en: "Email sending is temporarily paused. You can check the status later.",
      cs: "Odesílání e-mailů je dočasně pozastaveno. Stav si můžete ověřit později.",
    },
  "Pozrieť hodvábne šatky →": {
    en: "View silk scarves →",
    cs: "Prohlédnout hedvábné šátky →",
  },
  "Vyžiadať výsledok e-mailom": {
    en: "Request the result by email",
    cs: "Vyžádat výsledek e-mailem",
  },
  "E-mail neprišiel?": {
    en: "Did the email not arrive?",
    cs: "E-mail nepřišel?",
  },
  "Zadajte Vašu e-mailovú adresu znovu.": {
    en: "Enter your email address again.",
    cs: "Zadejte znovu svou e-mailovou adresu.",
  },
  "Poslať výsledok e-mailom →": {
    en: "Send the result by email →",
    cs: "Poslat výsledek e-mailem →",
  },
  "Začať nový kvíz": {
    en: "Start a new quiz",
    cs: "Začít nový kvíz",
  },
  "Začnime znova": {
    en: "Let us start again",
    cs: "Začněme znovu",
  },
  "Otvoriť kvíz": {
    en: "Open the quiz",
    cs: "Otevřít kvíz",
  },
  "Služba je dočasne nedostupná. Skúste to neskôr.": {
    en: "The service is temporarily unavailable. Please try again later.",
    cs: "Služba je dočasně nedostupná. Zkuste to později.",
  },
  "Neplatný identifikátor požiadavky.": {
    en: "Invalid request identifier.",
    cs: "Neplatný identifikátor požadavku.",
  },
  "Sprievodca sa aktualizoval. Obnovte stránku a skúste to znova.": {
    en: "The guide has been updated. Refresh the page and try again.",
    cs: "Průvodce byl aktualizován. Obnovte stránku a zkuste to znovu.",
  },
  "Túto požiadavku už evidujeme s inými odpoveďami.": {
    en: "This request has already been recorded with different answers.",
    cs: "Tento požadavek již evidujeme s jinými odpověďmi.",
  },
  "Výsledok sa nenašiel alebo už vypršal.": {
    en: "The result was not found or has expired.",
    cs: "Výsledek nebyl nalezen nebo již vypršel.",
  },
  "Príliš veľa požiadaviek. Skúste to o hodinu.": {
    en: "Too many requests. Try again in an hour.",
    cs: "Příliš mnoho požadavků. Zkuste to za hodinu.",
  },
  "Formulár sa nepodarilo odoslať.": {
    en: "The form could not be submitted.",
    cs: "Formulář se nepodařilo odeslat.",
  },
  "Zadajte tú istú e-mailovú adresu, ktorú ste použili v kvíze.": {
    en: "Enter the same email address you used in the quiz.",
    cs: "Zadejte stejnou e-mailovou adresu, kterou jste použila v kvízu.",
  },
  "Ďalšie odoslanie teraz nie je dostupné. Skontrolujte stav a skúste to neskôr.":
    {
      en: "Resending is not available now. Check the status and try again later.",
      cs: "Další odeslání nyní není dostupné. Zkontrolujte stav a zkuste to později.",
    },
  "Skontrolujte e-mailovú adresu.": {
    en: "Check your email address.",
    cs: "Zkontrolujte e-mailovou adresu.",
  },
  "Obnovte stránku a skontrolujte voľbu odberu.": {
    en: "Refresh the page and check your subscription choice.",
    cs: "Obnovte stránku a zkontrolujte volbu odběru.",
  },
  "Požiadavka už bola použitá s inými údajmi.": {
    en: "The request has already been used with different details.",
    cs: "Požadavek již byl použit s jinými údaji.",
  },
  "Na odber noviniek sme vás neprihlásili.": {
    en: "We have not subscribed you to news.",
    cs: "K odběru novinek jsme Vás nepřihlásili.",
  },
  "Na odber tipov a noviniek potrebujeme váš súhlas.": {
    en: "We need your consent to subscribe you to tips and news.",
    cs: "K odběru tipů a novinek potřebujeme Váš souhlas.",
  },
  "Požiadavka už bola použitá.": {
    en: "The request has already been used.",
    cs: "Požadavek již byl použit.",
  },
  "Tento odber bol odhlásený alebo pozastavený. Pre tipy a novinky použite formulár opätovného prihlásenia. Zaslanie vyžiadaného výsledku tým nie je podmienené.":
    {
      en: "This subscription was cancelled or suspended. Use the resubscription form for tips and news. This does not affect delivery of your requested result.",
      cs: "Tento odběr byl odhlášen nebo pozastaven. Pro tipy a novinky použijte formulář opětovného přihlášení. Zaslání vyžádaného výsledku tím není podmíněno.",
    },
  "Odber tipov a noviniek je potvrdený.": {
    en: "Your subscription to tips and news is confirmed.",
    cs: "Odběr tipů a novinek je potvrzen.",
  },
  "Pre tipy a novinky potvrďte odber v samostatnom e-maile. Vyžiadaný výsledok posielame aj bez potvrdenia odberu.":
    {
      en: "Confirm your subscription in the separate email to receive tips and news. We send the requested result even without subscription confirmation.",
      cs: "Pro tipy a novinky potvrďte odběr v samostatném e-mailu. Vyžádaný výsledek posíláme i bez potvrzení odběru.",
    },
  "Odber noviniek sa teraz nepodarilo prihlásiť. Odoslanie vyžiadaného výsledku tým nie je ovplyvnené.":
    {
      en: "We could not subscribe you to news right now. Delivery of your requested result is not affected.",
      cs: "K odběru novinek se nyní nepodařilo přihlásit. Odeslání vyžádaného výsledku tím není ovlivněno.",
    },
  "Neplatný odhlasovací odkaz.": {
    en: "Invalid unsubscribe link.",
    cs: "Neplatný odhlašovací odkaz.",
  },
  "Príliš veľa pokusov. Skúste to neskôr.": {
    en: "Too many attempts. Please try again later.",
    cs: "Příliš mnoho pokusů. Zkuste to později.",
  },
  "Príliš veľká požiadavka.": {
    en: "The request is too large.",
    cs: "Požadavek je příliš velký.",
  },
  "Neplatný formulár.": {
    en: "Invalid form.",
    cs: "Neplatný formulář.",
  },
  "Neplatné palety pri remíze": {
    en: "Invalid palettes for a tied result",
    cs: "Neplatné palety při remíze",
  },
  "Neplatná paleta": {
    en: "Invalid palette",
    cs: "Neplatná paleta",
  },
  "Neplatná ukážka": {
    en: "Invalid preview",
    cs: "Neplatná ukázka",
  },
  "Stránka sa nenašla.": {
    en: "Page not found.",
    cs: "Stránka nebyla nalezena.",
  },
  "Niečo sa nepodarilo. Vaše odpovede zostávajú v prehliadači; skúste to znova.":
    {
      en: "Something went wrong. Your answers remain in the browser; please try again.",
      cs: "Něco se nepodařilo. Vaše odpovědi zůstávají v prohlížeči; zkuste to znovu.",
    },
  "Odber odhlásený": {
    en: "Unsubscribed",
    cs: "Odběr odhlášen",
  },
  "Marketingové e-maily sme odhlásili.": {
    en: "You have been unsubscribed from marketing emails.",
    cs: "Marketingové e-maily jsme odhlásili.",
  },
  "Späť na Keyanu": {
    en: "Back to Keyana",
    cs: "Zpět na Keyanu",
  },
  "Odhlásenie odberu": {
    en: "Unsubscribe",
    cs: "Odhlášení odběru",
  },
  "Odhlásiť marketingové e-maily?": {
    en: "Unsubscribe from marketing emails?",
    cs: "Odhlásit marketingové e-maily?",
  },
  "Odhlásime farebné tipy aj odber v Mailchimpe. Správy k objednávkam tým nemeníte.":
    {
      en: "We will unsubscribe you from colour tips and Mailchimp news. This does not affect order-related messages.",
      cs: "Odhlásíme barevné tipy i odběr v Mailchimpu. Zprávy k objednávkám tím neměníte.",
    },
  "Áno, odhlásiť odber": {
    en: "Yes, unsubscribe",
    cs: "Ano, odhlásit odběr",
  },
  "Farebný sprievodca od Janky": {
    en: "Janka’s colour guide",
    cs: "Barevný průvodce od Janky",
  },
  "Načítavame sprievodcu…": {
    en: "Loading the guide…",
    cs: "Načítáme průvodce…",
  },
  "Pre dotazník zapnite JavaScript.": {
    en: "Enable JavaScript to use the questionnaire.",
    cs: "Pro dotazník zapněte JavaScript.",
  },
  "Prečítať o farebnej typológii": {
    en: "Read about colour analysis",
    cs: "Přečíst o barevné typologii",
  },
  "Vaše farby na vyskúšanie + tipy na prvý outfit": {
    en: "Your colours to try + tips for your first outfit",
    cs: "Vaše barvy k vyzkoušení + tipy na první outfit",
  },
  "Jedna šatka, tri spôsoby nosenia": {
    en: "One scarf, three ways to wear it",
    cs: "Jeden šátek, tři způsoby nošení",
  },
  "Ako zladiť šatku s tým, čo už máte doma": {
    en: "How to match a scarf with what you already own",
    cs: "Jak sladit šátek s tím, co už máte doma",
  },
  "Nemusíte meniť celý šatník. S tou istou šatkou skúste tri jednoduché možnosti.":
    {
      en: "You do not need to replace your whole wardrobe. Try three simple ways with the same scarf.",
      cs: "Nemusíte měnit celý šatník. Se stejným šátkem zkuste tři jednoduché možnosti.",
    },
  "1. Pri krku: zložte ju do úzkeho pásu a uviažte voľne. Otočte vzor tak, aby pri tvári zostala farba, ktorá vám vyhovuje.":
    {
      en: "1. Around your neck: fold it into a narrow band and tie it loosely. Turn the pattern so that a colour that suits you stays next to your face.",
      cs: "1. U krku: složte jej do úzkého pruhu a uvažte volně. Otočte vzor tak, aby u obličeje zůstala barva, která Vám vyhovuje.",
    },
  "2. Cez ramená: zložte ju do trojuholníka a nechajte voľne spočívať na jednofarebnom tope.":
    {
      en: "2. Over your shoulders: fold it into a triangle and let it rest loosely over a plain top.",
      cs: "2. Přes ramena: složte jej do trojúhelníku a nechte volně spočívat na jednobarevném topu.",
    },
  "3. Na kabelke: uviažte ju na rúčku. Oživí outfit, ale v tejto polohe neovplyvní farbu pri tvári.":
    {
      en: "3. On your handbag: tie it to the handle. It will brighten your outfit, but in this position it will not affect the colour next to your face.",
      cs: "3. Na kabelce: uvažte jej na ucho kabelky. Oživí outfit, ale v této poloze neovlivní barvu u obličeje.",
    },
  "Začnite oblečením, ktoré už nosíte. Nová šatka nemusí znamenať nový šatník.":
    {
      en: "Start with the clothes you already wear. A new scarf does not have to mean a new wardrobe.",
      cs: "Začněte oblečením, které už nosíte. Nový šátek nemusí znamenat nový šatník.",
    },
  "Ak pri porovnávaní farieb váhate, osobná konzultácia pomôže viac než ďalšie hádanie sezóny.":
    {
      en: "If you are unsure when comparing colours, a personal consultation will help more than another guess at your season.",
      cs: "Pokud při porovnávání barev váháte, osobní konzultace pomůže více než další hádání sezóny.",
    },
  "Jarná paleta": {
    en: "Spring palette",
    cs: "Jarní paleta",
  },
  "Letná paleta": {
    en: "Summer palette",
    cs: "Letní paleta",
  },
  "Jesenná paleta": {
    en: "Autumn palette",
    cs: "Podzimní paleta",
  },
  "Zimná paleta": {
    en: "Winter palette",
    cs: "Zimní paleta",
  },
  "Farebné tipy pre Vás": {
    en: "Colour tips for you",
    cs: "Barevné tipy pro Vás",
  },
  "Farby na skúšanie": {
    en: "Colours to try",
    cs: "Barvy k vyzkoušení",
  },
  "Šatky vo vašich farbách": {
    en: "Scarves in your colours",
    cs: "Šátky ve Vašich barvách",
  },
  "Pozrieť šatky vo vašich farbách": {
    en: "View scarves in your colours",
    cs: "Prohlédnout šátky ve Vašich barvách",
  },
  "Stav odoslania": {
    en: "Sending status",
    cs: "Stav odeslání",
  },
  "Tento jednorazový e-mail ste si vyžiadali vo farebnom kvíze KEYANA. Odber ďalších tipov a noviniek je dobrovoľný.":
    {
      en: "You requested this one-off email in the KEYANA colour quiz. Subscribing to further tips and news is optional.",
      cs: "Tento jednorázový e-mail jste si vyžádala v barevném kvízu KEYANA. Odběr dalších tipů a novinek je dobrovolný.",
    },
  "Keyana • Farebný sprievodca od Janky": {
    en: "Keyana • Janka’s colour guide",
    cs: "Keyana • Barevný průvodce od Janky",
  },
  "Výsledok je orientačný a nenahrádza osobnú konzultáciu.": {
    en: "The result is indicative and does not replace a personal consultation.",
    cs: "Výsledek je orientační a nenahrazuje osobní konzultaci.",
  },
  "Odhlásiť marketingové e-maily": {
    en: "Unsubscribe from marketing emails",
    cs: "Odhlásit marketingové e-maily",
  },
  "Pozrieť šatku": {
    en: "View scarf",
    cs: "Prohlédnout šátek",
  },
  "Vaša orientačná farebná paleta, tipy na nosenie a osobná konzultácia s Jankou.":
    {
      en: "Your indicative colour palette, styling tips and a personal consultation with Janka.",
      cs: "Vaše orientační barevná paleta, tipy na nošení a osobní konzultace s Jankou.",
    },
  "FAREBNÝ SPRIEVODCA": {
    en: "COLOUR GUIDE",
    cs: "BAREVNÝ PRŮVODCE",
  },
  UKÁŽKA: {
    en: "PREVIEW",
    cs: "UKÁZKA",
  },
  "Overiť stav odoslania": {
    en: "Check the sending status",
    cs: "Ověřit stav odeslání",
  },
  "PRACOVNÝ PREHĽAD PRE JANKU · V1.1": {
    en: "WORKING REVIEW FOR JANKA · V1.1",
    cs: "PRACOVNÍ PŘEHLED PRO JANKU · V1.1",
  },
  "Päť otázok. Vaša farebná stopa.": {
    en: "Five questions. Your colour profile.",
    cs: "Pět otázek. Vaše barevná stopa.",
  },
  "Otázky, bodovanie, farebné ukážky a výsledky podľa zadania KVIZ KEYANA. Tento prehľad neukladá odpovede, neprihlasuje na odber a neposiela e-maily.":
    {
      en: "Questions, scoring, colour samples and results based on the KVIZ KEYANA brief. This review does not save answers, subscribe anyone or send emails.",
      cs: "Otázky, bodování, barevné ukázky a výsledky podle zadání KVIZ KEYANA. Tento přehled neukládá odpovědi, nepřihlašuje k odběru a neposílá e-maily.",
    },
  "Prejsť skutočný dotazník →": {
    en: "Open the actual questionnaire →",
    cs: "Přejít na skutečný dotazník →",
  },
  "Otázky a farebné ukážky": {
    en: "Questions and colour samples",
    cs: "Otázky a barevné ukázky",
  },
  Odpoveď: {
    en: "Answer",
    cs: "Odpověď",
  },
  Vyhodnotenie: {
    en: "Evaluation",
    cs: "Vyhodnocení",
  },
  "Najvyšší súčet určí hlavnú paletu. Presah sa zobrazí iba pri rozdiele najviac 2 body: Q3=A len Jar/Jeseň, Q3=D len Leto/Zima, Q3=B/C aj medzi teplými a chladnými paletami. Pri Q3=E alebo rovnako silných sekundárnych možnostiach zostane iba hlavná paleta.":
    {
      en: "The highest score determines the main palette. An overlap is shown only when the difference is no more than 2 points: Q3=A only Spring/Autumn, Q3=D only Summer/Winter, Q3=B/C also between warm and cool palettes. With Q3=E or equally strong secondary options, only the main palette remains.",
      cs: "Nejvyšší součet určí hlavní paletu. Přesah se zobrazí pouze při rozdílu nejvýše 2 bodů: Q3=A jen Jaro/Podzim, Q3=D jen Léto/Zima, Q3=B/C i mezi teplými a chladnými paletami. Při Q3=E nebo stejně silných sekundárních možnostech zůstane pouze hlavní paleta.",
    },
  "Pri rovnosti najvyššieho skóre uvedieme všetky zhodné palety ako neistý výsledok. Žiadnu z nich nevyberáme ako jedinú hlavnú. Body sa zákazníčke nezobrazujú.":
    {
      en: "When the highest score is tied, all tied palettes are shown as an uncertain result. None is selected as the sole main palette. Scores are not shown to the customer.",
      cs: "Při rovnosti nejvyššího skóre uvedeme všechny shodné palety jako nejistý výsledek. Žádnou nevybíráme jako jedinou hlavní. Body se zákaznici nezobrazují.",
    },
  "Výsledky a e-maily": {
    en: "Results and emails",
    cs: "Výsledky a e-maily",
  },
  "Ukážky hlavných paliet, presahov a nerozhodných výsledkov s dvoma až štyrmi paletami.":
    {
      en: "Previews of main palettes, overlaps and tied results with two to four palettes.",
      cs: "Ukázky hlavních palet, přesahů a nerozhodných výsledků se dvěma až čtyřmi paletami.",
    },
  "E-mail: výsledok": {
    en: "Email: result",
    cs: "E-mail: výsledek",
  },
  "E-mail: deň 2": {
    en: "Email: day 2",
    cs: "E-mail: den 2",
  },
  "E-mail: deň 5": {
    en: "Email: day 5",
    cs: "E-mail: den 5",
  },
  "Skúste porovnať jarnú a jesennú paletu": {
    en: "Try comparing the spring and autumn palettes",
    cs: "Zkuste porovnat jarní a podzimní paletu",
  },
  "Skúste porovnať letnú a zimnú paletu": {
    en: "Try comparing the summer and winter palettes",
    cs: "Zkuste porovnat letní a zimní paletu",
  },
  "Teplejšie farby sú smerom na skúšanie. Na výber jednej sezóny zatiaľ nemáme dostatok stabilných pozorovaní.":
    {
      en: "Warmer colours are a direction to explore. There are not yet enough consistent observations to select one season.",
      cs: "Teplejší barvy jsou směrem k vyzkoušení. Pro výběr jedné sezóny zatím nemáme dostatek stabilních pozorování.",
    },
  "Chladnejšie farby sú smerom na skúšanie. Porovnajte tlmenú modrú s čistejšou modrou pri podobnej svetlosti.":
    {
      en: "Cooler colours are a direction to explore. Compare a muted blue with a clearer blue of similar lightness.",
      cs: "Chladnější barvy jsou směrem k vyzkoušení. Porovnejte tlumenou modrou s čistší modrou při podobné světlosti.",
    },
  "Toto sú možnosti na porovnanie teplejších farieb, nie potvrdenie jednej sezóny.":
    {
      en: "These are options for comparing warmer colours, not confirmation of one season.",
      cs: "Jde o možnosti k porovnání teplejších barev, nikoli o potvrzení jedné sezóny.",
    },
  "Toto sú možnosti na porovnanie chladnejších farieb, nie potvrdenie jednej sezóny.":
    {
      en: "These are options for comparing cooler colours, not confirmation of one season.",
      cs: "Jde o možnosti k porovnání chladnějších barev, nikoli o potvrzení jedné sezóny.",
    },
};

const normalizeLocale = (value) => {
  const locale = String(value || "sk")
    .toLowerCase()
    .split(/[-_]/)[0];
  return locale === "en" || locale === "cs" ? locale : "sk";
};
function localizeUrl(value, requestedLocale = "sk") {
  const locale = normalizeLocale(requestedLocale);
  if (locale === "sk") return value;
  try {
    const url = new URL(value, "https://www.keyana.sk");
    if (url.origin !== "https://www.keyana.sk") return value;
    url.pathname =
      `/${locale}${url.pathname.replace(/^\/(en|cs|sk)(?=\/|$)/, "")}`.replace(
        /\/$/,
        "",
      );
    return url.href;
  } catch {
    return value;
  }
}
function translate(value, requestedLocale = "sk") {
  const locale = normalizeLocale(requestedLocale);
  if (locale === "sk" || typeof value !== "string") return value;
  if (COPY[value]?.[locale]) return COPY[value][locale];
  let m;
  if ((m = value.match(/^([A-E]\) )(.+)$/)))
    return m[1] + translate(m[2], locale);
  if ((m = value.match(/^OTÁZKA (\d) \/ 5$/)))
    return `${locale === "en" ? "QUESTION" : "OTÁZKA"} ${m[1]} / 5`;
  if (
    (m = value.match(
      /^K jednofarebnej košeli a džínsom skúste (.+) akcent pri krku\.$/,
    ))
  )
    return locale === "en"
      ? `With a plain shirt and jeans, try a ${translate(m[1], locale)} accent around your neck.`
      : `K jednobarevné košili a džínům zkuste ${translate(m[1], locale)} akcent u krku.`;
  if (
    (m = value.match(
      /^Vaša farebnosť však pôsobí pomerne neutrálne a môžete krásne fungovať aj v časti palety (Jari|Leta|Jesene|Zimy)\.$/,
    ))
  ) {
    const season = {
      Jari: ["spring", "jarní"],
      Leta: ["summer", "letní"],
      Jesene: ["autumn", "podzimní"],
      Zimy: ["winter", "zimní"],
    }[m[1]];
    return locale === "en"
      ? `Your colouring appears fairly neutral, so some colours from the ${season[0]} palette may also work beautifully for you.`
      : `Vaše barevnost však působí poměrně neutrálně a mohou Vám krásně slušet také některé barvy z ${season[1]} palety.`;
  }
  if (
    (m = value.match(
      /^Vaša farebná stopa smeruje k (dvom|trom|štyrom) paletám$/,
    ))
  ) {
    const count = {
      dvom: ["two", "dvěma"],
      trom: ["three", "třem"],
      štyrom: ["four", "čtyřem"],
    }[m[1]];
    return locale === "en"
      ? `Your colour profile points towards ${count[0]} palettes`
      : `Vaše barevná stopa směřuje ke ${count[1]} paletám`;
  }
  if (
    (m = value.match(
      /^Vaše odpovede smerujú k (dvom|trom|štyrom) farebným paletám\. Online kvíz ich nedokáže spoľahlivo odlíšiť\. Presnejší výsledok získate osobnou analýzou\. Palety na porovnanie: (.+)\.$/,
    ))
  ) {
    const count = {
        dvom: ["two", "dvěma"],
        trom: ["three", "třem"],
        štyrom: ["four", "čtyřem"],
      }[m[1]],
      names = m[2]
        .split(" / ")
        .map((s) => translate(s, locale))
        .join(" / ");
    return locale === "en"
      ? `Your answers point towards ${count[0]} colour palettes. An online quiz cannot reliably distinguish between them. A personal analysis will give you a more precise result. Palettes to compare: ${names}.`
      : `Vaše odpovědi směřují ke ${count[1]} barevným paletám. Online kvíz je nedokáže spolehlivě rozlišit. Přesnější výsledek získáte osobní analýzou. Palety k porovnání: ${names}.`;
  }
  if (value.startsWith("Remíza: "))
    return `${locale === "en" ? "Tie" : "Remíza"}: ${value
      .slice(8)
      .split(" / ")
      .map((s) => translate(s, locale))
      .join(" / ")}`;
  if (
    (m = value.match(
      /^Verzia: ([^.]+(?:\.[^ ]+)?)\. Marketingový súhlas je dobrovoľný; samotné zadanie e-mailu nikoho neprihlasuje do Mailchimpu\.$/,
    ))
  )
    return locale === "en"
      ? `Version: ${m[1]}. Marketing consent is optional; entering an email address alone does not subscribe anyone to Mailchimp.`
      : `Verze: ${m[1]}. Marketingový souhlas je dobrovolný; samotné zadání e-mailu nikoho nepřihlašuje do Mailchimpu.`;
  return value;
}
function localizeData(value, locale = "sk") {
  if (typeof value === "string") return translate(value, locale);
  if (Array.isArray(value)) return value.map((v) => localizeData(v, locale));
  if (value && typeof value === "object")
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [k, localizeData(v, locale)]),
    );
  return value;
}
function localizeDom(root, requestedLocale = "sk") {
  const locale = normalizeLocale(requestedLocale);
  root.lang = locale;
  if (locale === "sk") return;
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  for (let node; (node = walker.nextNode());) {
    if (node.parentElement?.closest("[data-kq-invariant],script,style"))
      continue;
    const original = node.textContent,
      trimmed = original.trim(),
      translated = translateContent(trimmed, locale);
    if (translated !== trimmed)
      node.textContent = original.replace(trimmed, translated);
  }
  for (const element of root.querySelectorAll(
    "[aria-label],[placeholder],[title]",
  ))
    for (const attr of ["aria-label", "placeholder", "title"]) {
      const value = element.getAttribute(attr);
      if (value) element.setAttribute(attr, translate(value, locale));
    }
  for (const a of root.querySelectorAll("a[href]")) {
    const value = a.getAttribute("href");
    if (value?.startsWith("https://www.keyana.sk"))
      a.href = localizeUrl(value, locale);
    if (value?.includes("/review/email?")) {
      const url = new URL(value, location.href);
      url.searchParams.set("locale", locale);
      a.href = url.href;
    }
  }
}

const escapePattern = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const copyPattern = new RegExp(
  `(?<![\\p{L}\\p{N}_])(?:${Object.keys(COPY)
    .sort((a, b) => b.length - a.length)
    .map(escapePattern)
    .join("|")})(?![\\p{L}\\p{N}_])`,
  "gu",
);
function translateContent(value, requestedLocale = "sk") {
  const locale = normalizeLocale(requestedLocale);
  if (locale === "sk") return value;
  const exact = translate(value, locale);
  return exact !== value
    ? exact
    : value.replace(copyPattern, (source) => COPY[source][locale]);
}
const decodeText = (value) =>
  value.replace(
    /&(?:amp|lt|gt|quot|#39);/g,
    (entity) =>
      ({ "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" })[
        entity
      ],
  );
const encodeText = (value) =>
  value.replace(
    /[&<>"']/g,
    (c) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[
        c
      ],
  );
function localizeMarkup(html, requestedLocale = "sk") {
  const locale = normalizeLocale(requestedLocale);
  if (locale === "sk") return html;
  const stack = [];
  return html.replace(/<[^>]*>|[^<]+/g, (part) => {
    if (!part.startsWith("<")) {
      if (stack.some((t) => t.preserve)) return part;
      const decoded = decodeText(part),
        trimmed = decoded.trim(),
        translated = translateContent(trimmed, locale);
      return translated === trimmed
        ? part
        : decoded.replace(trimmed, encodeText(translated));
    }
    const closing = part.match(/^<\/([a-z][a-z0-9]*)/i),
      opening = part.match(/^<([a-z][a-z0-9]*)/i);
    if (closing) {
      const index = stack
        .map((t) => t.name)
        .lastIndexOf(closing[1].toLowerCase());
      if (index >= 0) stack.splice(index);
    } else if (
      opening &&
      !/\b(?:area|base|br|col|embed|hr|img|input|link|meta|param|source|track|wbr)\b/i.test(
        opening[1],
      ) &&
      !/\/>$/.test(part)
    )
      stack.push({
        name: opening[1].toLowerCase(),
        preserve:
          /^(style|script)$/i.test(opening[1]) ||
          part.includes("data-kq-invariant"),
      });
    return part
      .replace(/(<html\b[^>]*\blang=)"[^"]+"/i, `$1"${locale}"`)
      .replace(
        /\bhref="(https:\/\/www\.keyana\.sk[^"\s]*)"/g,
        (_, url) => `href="${localizeUrl(url, locale)}"`,
      );
  });
}
function localizeEmailContent(
  message,
  requestedLocale = "sk",
  invariants = [],
) {
  const locale = normalizeLocale(requestedLocale);
  if (locale === "sk") return message;
  let text = message.text;
  invariants.filter(Boolean).forEach((value, index) => {
    text = text.split(value).join(`__KEYANA_INVARIANT_${index}__`);
  });
  text = text
    .split("\n")
    .map((line) => translateContent(line, locale))
    .join("\n")
    .replace(/https:\/\/www\.keyana\.sk[^\s]*/g, (url) =>
      localizeUrl(url, locale),
    );
  invariants.filter(Boolean).forEach((value, index) => {
    text = text.split(`__KEYANA_INVARIANT_${index}__`).join(value);
  });
  return {
    subject: translate(message.subject, locale),
    html: localizeMarkup(message.html, locale),
    text,
  };
}

const KEYANA_ATTRIBUTION_STORAGE = "keyana-acquisition-v1";
const KEYANA_ATTRIBUTION_TTL = 30 * 86400000;
const KEYANA_ATTRIBUTION_FIELDS = {
  utm_source: "source",
  utm_medium: "medium",
  utm_campaign: "campaign",
  utm_content: "content",
  utm_term: "term",
  utm_id: "campaign_id",
  campaign_id: "campaign_id",
  adset_id: "adset_id",
  ad_id: "ad_id",
  utm_source_platform: "source_platform",
};
const KEYANA_GOOGLE_REFERRER =
  /(^|\.)google\.(?:com|sk|cz|de|at|pl|hu|co\.uk|fr|it|es)$/;
const KEYANA_INTERNAL_HOSTS = new Set([
  "www.keyana.sk",
  "keyana.sk",
  "www.onebyone.sk",
  "onebyone.sk",
  "vxrdhk-xc.myshopify.com",
]);

function attributionText(value, limit = 128) {
  if (typeof value !== "string") return "";
  const text = value.normalize("NFKC").trim();
  // Attribution is a bounded label, never an arbitrary URL, query or identifier.
  return text.length &&
    text.length <= limit &&
    /^[\p{L}\p{N} _.|\-]+$/u.test(text)
    ? text
    : "";
}
function attributionHost(value) {
  try {
    const url = new URL(value);
    return ["http:", "https:"].includes(url.protocol) &&
      /^[a-z0-9.-]+$/.test(url.hostname) &&
      url.hostname.length <= 253
      ? url.hostname.toLowerCase()
      : "";
  } catch {
    return "";
  }
}
function attributionLandingPath(path) {
  // Keep public catalogue/content routes only; never account/order/token paths.
  return typeof path === "string" &&
    path.length <= 160 &&
    /^(?:\/(?:en|cs))?(?:\/|\/(?:pages|collections|products)\/[a-z0-9][a-z0-9-]{0,100})$/.test(
      path,
    )
    ? path
    : "/";
}
function attributionSource(value) {
  const lower = value.toLowerCase();
  if (["ig", "instagram", "instagram.com", "l.instagram.com"].includes(lower))
    return "instagram";
  if (["fb", "facebook", "facebook.com", "l.facebook.com"].includes(lower))
    return "facebook";
  if (["google", "googleads", "google_ads"].includes(lower)) return "google";
  if (["meta", "an", "msg", "audience_network", "messenger"].includes(lower))
    return "meta";
  return lower;
}
function isHost(host, domain) {
  return host === domain || host.endsWith(`.${domain}`);
}
function pageAcquisition(location, referrer, capturedAt, marketingAllowed) {
  const search = new URLSearchParams(location.search);
  const touch = {
    source: "direct",
    medium: "none",
    landing_path: attributionLandingPath(location.pathname),
    captured_at: capturedAt,
  };
  for (const [parameter, field] of Object.entries(KEYANA_ATTRIBUTION_FIELDS)) {
    const text = attributionText(search.get(parameter));
    if (text && !touch[field]) touch[field] = text;
    // Defaults do not suppress explicitly provided source/medium labels.
    if (text && ["source", "medium"].includes(field)) touch[field] = text;
  }
  const referrerHost = attributionHost(referrer);
  if (referrerHost && !KEYANA_INTERNAL_HOSTS.has(referrerHost)) {
    touch.referrer_host = referrerHost;
    if (!attributionText(search.get("utm_source"))) {
      touch.source = isHost(referrerHost, "instagram.com")
        ? "instagram"
        : isHost(referrerHost, "facebook.com") || referrerHost === "fb.com"
          ? "facebook"
          : KEYANA_GOOGLE_REFERRER.test(referrerHost)
            ? "google"
            : referrerHost;
      if (!attributionText(search.get("utm_medium"))) touch.medium = "referral";
    }
  }
  if (touch.source === "direct" && (touch.campaign || touch.medium !== "none"))
    touch.source = "unknown";
  touch.source = attributionSource(touch.source);
  touch.medium = touch.medium.toLowerCase();
  if (marketingAllowed) {
    for (const name of ["gclid", "gbraid", "wbraid", "fbclid"]) {
      // Retain only the kind of ad-click signal, never its value.
      const value = search.get(name);
      const googleClick = ["gclid", "gbraid", "wbraid"].includes(name);
      if (
        googleClick &&
        !["direct", "unknown", "google"].includes(touch.source)
      )
        continue;
      if (name === "fbclid" && touch.source === "google") continue;
      if (value && value.length <= 512 && /^[A-Za-z0-9_-]+$/.test(value)) {
        touch.click_id_type = name;
        break;
      }
    }
  }
  return touch;
}
function validAttributionTouch(value, now, marketingAllowed) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return;
  if (
    !Number.isFinite(value.captured_at) ||
    value.captured_at < now - KEYANA_ATTRIBUTION_TTL ||
    value.captured_at > now + 300000
  )
    return;
  const touch = {
    source: attributionSource(attributionText(value.source) || "unknown"),
    medium: (attributionText(value.medium) || "unknown").toLowerCase(),
    landing_path: attributionLandingPath(value.landing_path),
    captured_at: value.captured_at,
  };
  for (const field of new Set(Object.values(KEYANA_ATTRIBUTION_FIELDS))) {
    if (["source", "medium"].includes(field)) continue;
    const text = attributionText(value[field]);
    if (text) touch[field] = text;
  }
  const host = attributionHost(`https://${value.referrer_host || ""}`);
  if (host && !KEYANA_INTERNAL_HOSTS.has(host)) touch.referrer_host = host;
  if (
    marketingAllowed &&
    ["gclid", "gbraid", "wbraid", "fbclid"].includes(value.click_id_type)
  )
    touch.click_id_type = value.click_id_type;
  return touch;
}
function isAcquisitionTouch(touch) {
  return (
    !["direct", "unknown"].includes(touch.source) ||
    Boolean(touch.campaign || touch.click_id_type)
  );
}

function installKeyanaAttribution({
  window: win,
  document: doc,
  location = win.location,
  now = () => Date.now(),
}) {
  if (win.KeyanaAttribution?.version === 1) return win.KeyanaAttribution;
  const initialTime = now();
  // Capture the entry evidence before quiz history removes flags/query fields.
  // It remains in memory only until analytics consent allows measurement.
  const initialTouch = pageAcquisition(
    location,
    doc.referrer || "",
    initialTime,
    true,
  );
  const query = new URLSearchParams(location.search);
  const productionPage =
    location.protocol === "https:" &&
    location.hostname === "www.keyana.sk" &&
    !win.Shopify?.designMode &&
    !query.has("preview_theme_id") &&
    !query.has("preview") &&
    query.get("review") !== "1";
  let memory,
    timer,
    attempts = 0;
  function clear() {
    memory = undefined;
    try {
      win.localStorage.removeItem(KEYANA_ATTRIBUTION_STORAGE);
    } catch {
      /* Optional attribution never blocks the store. */
    }
  }
  function synchronize() {
    try {
      if (!productionPage || win.Shopify?.designMode) return;
      const privacy = win.Shopify?.customerPrivacy;
      if (
        typeof privacy?.analyticsProcessingAllowed !== "function" ||
        typeof privacy?.marketingAllowed !== "function"
      )
        return;
      if (
        privacy.analyticsProcessingAllowed() !== true ||
        privacy.marketingAllowed() !== true
      ) {
        clear();
        return;
      }
      const marketingAllowed = true;
      const timestamp = now();
      let saved = memory;
      try {
        saved = JSON.parse(
          win.localStorage.getItem(KEYANA_ATTRIBUTION_STORAGE),
        );
      } catch {
        /* Storage can be unavailable; the current page still works. */
      }
      if (saved?.version !== 1) saved = undefined;
      let first = validAttributionTouch(
        saved?.first_touch,
        timestamp,
        marketingAllowed,
      );
      let last = validAttributionTouch(
        saved?.last_touch,
        timestamp,
        marketingAllowed,
      );
      if (first && last && first.captured_at > last.captured_at) {
        first = undefined;
        last = undefined;
      }
      const current = validAttributionTouch(
        initialTouch,
        timestamp,
        marketingAllowed,
      );
      if (!current && !first && !last) {
        clear();
        return;
      }
      let firstTouch = first || last || current;
      if (!isAcquisitionTouch(firstTouch)) {
        if (last && isAcquisitionTouch(last)) firstTouch = last;
        if (
          current &&
          isAcquisitionTouch(current) &&
          !isAcquisitionTouch(firstTouch)
        )
          firstTouch = current;
      }
      let lastTouch = last || first || current;
      if (
        current &&
        isAcquisitionTouch(current) &&
        current.captured_at >= lastTouch.captured_at
      )
        lastTouch = current;
      // Same-page delayed advertising consent can enrich only this same touch.
      if (current && firstTouch.captured_at === current.captured_at)
        Object.assign(firstTouch, current);
      memory = {
        version: 1,
        analytics_allowed: true,
        marketing_allowed: marketingAllowed,
        first_touch: firstTouch,
        last_touch: lastTouch,
      };
      try {
        win.localStorage.setItem(
          KEYANA_ATTRIBUTION_STORAGE,
          JSON.stringify(memory),
        );
      } catch {
        /* In-memory attribution remains available without persistent storage. */
      }
      return JSON.parse(JSON.stringify(memory));
    } catch {
      return;
    }
  }
  function initialize() {
    synchronize();
    if (
      !productionPage ||
      (typeof win.Shopify?.customerPrivacy?.analyticsProcessingAllowed ===
        "function" &&
        typeof win.Shopify?.customerPrivacy?.marketingAllowed === "function") ||
      timer ||
      attempts >= 20
    )
      return;
    attempts++;
    timer = win.setTimeout(() => {
      timer = undefined;
      initialize();
    }, 250);
  }
  const api = { version: 1, getSnapshot: synchronize };
  win.KeyanaAttribution = api;
  if (productionPage) {
    doc.addEventListener("visitorConsentCollected", () => {
      // Shopify processes the shared consent notification before we re-read it.
      win.setTimeout(initialize, 0);
    });
    initialize();
  }
  return api;
}

if (typeof window !== "undefined" && typeof document !== "undefined") {
  try {
    installKeyanaAttribution({ window, document });
  } catch {
    /* Attribution must not prevent the storefront or quiz from loading. */
  }
}

const QUIZ_ANALYTICS_DESTINATION = "G-MQ5T7X5HPL";
const QUIZ_ADS_DESTINATION = "AW-18538004688/mSQpCJbN9q4dENCBzodF";
const QUIZ_META_DESTINATION = "915537152525807";

// Keep only acquisition parameters while the quiz changes its own UI state.
// Email addresses, review flags and private result links are never copied here.
function quizHistoryPath(location, hash = "") {
  const source = new URLSearchParams(location.search);
  const kept = new URLSearchParams();
  for (const name of [
    "gclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "utm_id",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "utm_source_platform",
    "utm_creative_format",
    "utm_marketing_tactic",
  ]) {
    const value = source.get(name);
    if (value && value.length <= 512) kept.set(name, value);
  }
  const query = kept.toString();
  return `${location.pathname}${query ? `?${query}` : ""}${hash}`;
}

function createQuizCompletionTracking({
  window: win,
  document: doc,
  location,
  preview = false,
  review = false,
  locale,
  version,
  getState,
  persist,
}) {
  let pending,
    timer,
    attempts = 0,
    adsConfigured = false,
    listening = false;
  // Latch preview eligibility before history updates remove non-attribution
  // parameters; a theme preview must never become a production measurement.
  const productionPage =
    !preview &&
    !review &&
    !win.Shopify?.designMode &&
    location.protocol === "https:" &&
    location.hostname === "www.keyana.sk" &&
    !new URLSearchParams(location.search).has("preview_theme_id");
  const allowedPage = () => productionPage && !win.Shopify?.designMode;
  const persistSafely = () => {
    try {
      persist();
    } catch {
      /* Measurement must never affect the quiz. */
    }
  };
  function recordMetaCompletion() {
    try {
      if (!allowedPage()) return;
      const privacy = win.Shopify?.customerPrivacy;
      if (
        privacy?.analyticsProcessingAllowed?.() !== true ||
        privacy?.marketingAllowed?.() !== true ||
        privacy?.saleOfDataAllowed?.() === false
      )
        return;
      // Reuse Shopify's consented Meta pixel. Do not install another base
      // pixel or queue calls against an unloaded library. This call must run
      // synchronously, before the private delivery token enters the URL.
      if (
        typeof win.fbq !== "function" ||
        typeof win.fbq.callMethod !== "function"
      )
        return;
      if (
        location.hash ||
        `${location.pathname}${location.search}` !== quizHistoryPath(location)
      )
        return;
      const state = getState();
      if (state.metaCompletionTracking?.sent) return;
      state.metaCompletionTracking ||= {
        eventId: `keyana-quiz-${win.crypto.randomUUID()}`,
        sent: false,
      };
      state.metaCompletionTracking.sent = true;
      persistSafely();
      win.fbq(
        "trackSingle",
        QUIZ_META_DESTINATION,
        "Lead",
        {
          content_name: "KEYANA colour quiz",
        },
        { eventID: state.metaCompletionTracking.eventId },
      );
    } catch {
      /* Measurement must never affect the saved guide or its delivery. */
    }
  }
  const retry = () => {
    if (timer || attempts >= 20) return;
    attempts++;
    timer = win.setTimeout(() => {
      timer = undefined;
      flush();
    }, 250);
  };
  function flush() {
    try {
      if (!allowedPage()) return;
      const privacy = win.Shopify?.customerPrivacy;
      if (
        typeof privacy?.analyticsProcessingAllowed !== "function" ||
        typeof privacy?.marketingAllowed !== "function"
      )
        return retry();
      if (privacy.analyticsProcessingAllowed() !== true) return;
      if (typeof win.gtag !== "function") return retry();
      const marketingAllowed = privacy.marketingAllowed() === true;
      if (marketingAllowed && !adsConfigured) {
        try {
          // Capture permitted acquisition data as soon as consent and the
          // existing tag are ready. Never expose arbitrary query data or #r.
          win.gtag("config", QUIZ_ADS_DESTINATION.split("/")[0], {
            send_page_view: false,
            page_location: `${location.origin}${quizHistoryPath(location)}`,
            allow_ad_personalization_signals: false,
            allow_enhanced_conversions: false,
          });
          adsConfigured = true;
        } catch {
          /* Analytics/result delivery remain independent of Ads readiness. */
        }
      }
      if (!pending || getState() !== pending) return;
      const flags = pending.completionTracking;
      const parameters = {
        lead_source: "colour_quiz",
        quiz_version: version,
        quiz_locale: ["sk", "en", "cs"].includes(locale) ? locale : "sk",
        page_location: `${location.origin}${location.pathname}`,
      };
      if (!flags.analyticsSent) {
        // Mark before invoking a third-party function: even a throwing tag
        // cannot turn the same completion into repeated conversion attempts.
        flags.analyticsSent = true;
        persistSafely();
        try {
          win.gtag("event", "generate_lead", {
            ...parameters,
            send_to: QUIZ_ANALYTICS_DESTINATION,
          });
        } catch {
          /* Result delivery remains independent of analytics. */
        }
      }
      if (!flags.adsSent && marketingAllowed && adsConfigured) {
        try {
          flags.adsSent = true;
          persistSafely();
          win.gtag("event", "conversion", {
            ...parameters,
            send_to: QUIZ_ADS_DESTINATION,
          });
        } catch {
          /* Result delivery remains independent of advertising. */
        }
      }
    } catch {
      /* Consent/tag/storage failures must not block completion. */
    }
  }
  function consentChanged() {
    attempts = 0;
    // Let the existing Google app process the same consent notification first.
    try {
      win.setTimeout(flush, 0);
    } catch {
      /* No tracking on timer failure. */
    }
  }
  function listen() {
    if (!listening && allowedPage()) {
      doc.addEventListener("visitorConsentCollected", consentChanged);
      listening = true;
    }
  }
  try {
    listen();
    flush();
  } catch {
    /* Optional measurement initialization must not stop the questionnaire. */
  }
  return {
    recordSuccessfulCompletion() {
      // An actual accepted submission is the only Meta conversion boundary.
      // Do not replay it on consent changes or restored private result URLs.
      recordMetaCompletion();
      try {
        if (!allowedPage()) return;
        pending = getState();
        pending.completionTracking ||= { analyticsSent: false, adsSent: false };
        listen();
        attempts = 0;
        flush();
      } catch {
        /* A saved guide always proceeds to its delivery screen. */
      }
    },
  };
}

// Suggestions only: never silently rewrite an address or reject unfamiliar domains.
const EMAIL_DOMAIN_TYPOS = new Map([
  ["gmail.sk", "gmail.com"],
  ["gmail.cz", "gmail.com"],
  ["gmial.com", "gmail.com"],
  ["gamil.com", "gmail.com"],
  ["gmai.com", "gmail.com"],
  ["gmail.con", "gmail.com"],
  ["gmail.cmo", "gmail.com"],
  ["outlok.com", "outlook.com"],
  ["outllook.com", "outlook.com"],
  ["hotmial.com", "hotmail.com"],
  ["hotmai.com", "hotmail.com"],
  ["yaho.com", "yahoo.com"],
  ["yahoo.con", "yahoo.com"],
  ["iclod.com", "icloud.com"],
  ["icloud.con", "icloud.com"],
]);

function emailDomainSuggestion(value) {
  const email = String(value).trim();
  const parts = email.split("@");
  if (parts.length !== 2 || !parts[0] || /\s/.test(email)) return null;
  const domain = EMAIL_DOMAIN_TYPOS.get(parts[1].toLowerCase());
  return domain ? { domain, email: `${parts[0]}@${domain}` } : null;
}

function createEmailTypoGuard({ input, panel, translate, onChange }) {
  let confirmedEmail = null;
  return {
    reset() {
      if (input.value.trim() === confirmedEmail) return;
      confirmedEmail = null;
      panel.hidden = true;
    },
    check() {
      const original = input.value.trim();
      const suggestion = emailDomainSuggestion(original);
      if (!suggestion || original === confirmedEmail) return true;
      panel.hidden = false;
      const use = panel.querySelector("[data-email-correct]");
      const keep = panel.querySelector("[data-email-keep]");
      use.textContent = `${translate("Použiť doménu")} ${suggestion.domain}`;
      use.onclick = () => {
        // Ignore an obsolete suggestion if the field was edited meanwhile.
        if (input.value.trim() !== original) return;
        input.value = suggestion.email;
        confirmedEmail = null;
        panel.hidden = true;
        onChange();
        input.focus();
      };
      keep.onclick = () => {
        if (input.value.trim() !== original) return;
        confirmedEmail = original;
        panel.hidden = true;
        input.focus();
      };
      use.focus();
      return false;
    },
  };
}

const esc = (value) =>
  String(value ?? "").replace(
    /[&<>"']/g,
    (c) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[
        c
      ],
  );
const money = (value) =>
  new Intl.NumberFormat(document.documentElement.lang || "sk-SK", {
    style: "currency",
    currency: "EUR",
  }).format(value);
const safeUrl = (value, images = false) => {
  try {
    const u = new URL(value, "https://www.keyana.sk");
    return u.protocol === "https:" &&
      (u.hostname === "www.keyana.sk" ||
        (images && u.hostname === "cdn.shopify.com"))
      ? u.href
      : "";
  } catch {
    return "";
  }
};
for (const root of document.querySelectorAll("[data-keyana-quiz]")) {
  if (root.dataset.started) continue;
  root.dataset.started = "true";
  root.classList.add("kq");
  root.setAttribute("data-clarity-mask", "true");
  const locale = normalizeLocale(
    root.dataset.locale || document.documentElement.lang,
  );
  const t = (value) => translate(value, locale);
  const api = root.dataset.api || "",
    preview = root.dataset.preview === "true",
    review = new URLSearchParams(location.search).get("review") === "1";
  const key = "keyana-quiz-janka-v1" + (locale === "sk" ? "" : `-${locale}`);
  const fresh = () => ({
    version: VERSION,
    phase: "intro",
    answers: {},
    index: 0,
    requestId: crypto.randomUUID(),
    updated: Date.now(),
  });
  let state = fresh(),
    busy = false,
    deliveryTimer;
  const productCache = new Map();
  try {
    const saved = JSON.parse(sessionStorage.getItem(key));
    if (saved?.version === VERSION && saved.updated > Date.now() - 86400000)
      state = saved;
  } catch {
    console.warn("Colour guide: saved progress unavailable.");
  }
  function persist() {
    state.updated = Date.now();
    try {
      sessionStorage.setItem(key, JSON.stringify(state));
    } catch {
      console.warn("Colour guide: session storage unavailable.");
    }
  }
  let acquisition;
  try {
    acquisition = installKeyanaAttribution({ window, document, location });
  } catch {
    /* Optional attribution must not stop the requested guide. */
  }
  const attributionSnapshot = () => {
    if (preview || review) return;
    try {
      return acquisition?.getSnapshot();
    } catch {
      /* An unavailable source label must never block result delivery. */
    }
  };
  const completionTracking = createQuizCompletionTracking({
    window,
    document,
    location,
    preview,
    review,
    locale,
    version: VERSION,
    getState: () => state,
    persist,
  });
  const notice =
    preview || review
      ? `<div class="kq-notice"><span class="kq-dot"></span><strong>BETA NA PRIPOMIENKOVANIE</strong><span>Päť otázok a bodovanie podľa Janky · V1.1</span>${preview ? "<span>Lokálna ukážka — e-maily sa neodosielajú.</span>" : ""}</div>`
      : "";
  const swatches = (colors) =>
    `<div class="kq-swatches">${colors.map(([n, c]) => `<div><span style="background:${esc(c)}" aria-hidden="true"></span><small>${esc(n)}</small></div>`).join("")}</div>`;
  const answerImages = {
    q3: { A: "q3-a", B: "q3-b", C: "q3-c", D: "q3-d" },
    q4: { A: "q4-a", B: "q4-b", C: "q4-c" },
    q5: { A: "q5-a", B: "q5-b", C: "q5-c" },
  };
  const optionColors = (q, o) => {
    const name = answerImages[q.id]?.[o.value];
    if (name) {
      const url =
        root.dataset[
          `image${name
            .split("-")
            .map((p) => p[0].toUpperCase() + p.slice(1))
            .join("")}`
        ] || `/palettes/keyana-quiz-${name}-20261013-v11.jpg`;
      return `<img class="kq-option-image" src="${esc(url)}" alt="" width="2048" height="975">`;
    }
    return o.colors?.length
      ? `<span class="kq-option-colors" aria-hidden="true">${o.colors.map((c) => `<i style="background:${esc(c)}"></i>`).join("")}</span>`
      : "";
  };
  const optionMarkup = (q, selected) =>
    q.options
      .map(
        (o) =>
          `<label class="kq-option ${q.visual ? "kq-palette-option" : ""} ${!o.colors.length && q.visual ? "kq-unknown" : ""}"><input type="radio" name="answer" value="${o.value}" ${selected === o.value ? "checked" : ""}><span class="kq-option-content"><span>${o.value}) ${esc(o.label)}</span>${optionColors(q, o)}</span></label>`,
      )
      .join("");
  async function request(path, body) {
    const requestUrl = new URL(`${api}${path}`, location.href);
    requestUrl.searchParams.set("locale", locale);
    const r = await fetch(requestUrl, {
      method: body ? "POST" : "GET",
      headers: body ? { "Content-Type": "application/json" } : {},
      body: body ? JSON.stringify({ ...body, locale }) : undefined,
      signal: AbortSignal.timeout(20000),
      credentials: "omit",
    });
    const d = await r.json();
    if (!r.ok)
      throw new Error(
        d.error || "Služba je dočasne nedostupná. Skúste to neskôr.",
      );
    return d;
  }
  function focus() {
    root.querySelector("[data-focus]")?.focus({ preventScroll: true });
    root.scrollIntoView({
      block: "start",
      behavior: matchMedia("(prefers-reduced-motion: reduce)").matches
        ? "instant"
        : "smooth",
    });
  }
  function message(text) {
    const m = root.querySelector("[data-message]");
    if (m) m.textContent = t(text);
  }
  function go(phase) {
    state.phase = phase;
    persist();
    render();
    focus();
  }
  function reset() {
    state = fresh();
    history.replaceState(null, "", quizHistoryPath(location));
    go("intro");
  }
  function subscriptionMarkup() {
    const s = state.subscription;
    if (!s) return "";
    let resub = "";
    try {
      const u = new URL(s.resubscribeUrl);
      if (u.protocol === "https:" && u.hostname.endsWith(".list-manage.com"))
        resub = ` <a href="${esc(u.href)}" target="_blank" rel="noopener">Opätovne potvrdiť odber ↗</a>`;
    } catch {}
    return `<p class="kq-subscription" role="status">${esc(s.message)}${resub}</p>`;
  }
  function resultMarkup(r, isReview = false) {
    return `<section class="kq-result"><p class="kq-eyebrow">${isReview ? "UKÁŽKA VÝSLEDKU" : "VAŠA FAREBNÁ PALETA"}</p><h1 data-focus tabindex="-1">${esc(r.title)}</h1><p class="kq-lead">${esc(r.description)}</p>${r.secondaryText ? `<p class="kq-secondary">${esc(r.secondaryText)}</p>` : ""}<p class="kq-caveat">${esc(r.caveat)}</p>${r.colors.length ? swatches(r.colors) : ""}<div class="kq-section-heading"><div><p class="kq-eyebrow">HODVÁB VO VAŠICH FARBÁCH</p><h2>Šatky vybrané pre vás</h2></div><p>${esc(r.productIntro || r.reason)}</p></div><div class="kq-products" data-products><p>Načítavame aktuálny výber…</p></div><p class="kq-collection-links">${r.collections.map((c) => `<a href="https://www.keyana.sk/collections/${esc(c)}">Pozrieť ${{ "jarny-typ": "jarnú", "letny-typ": "letnú", "jesenny-typ": "jesennú", "zimny-typ": "zimnú" }[c]} kolekciu ↗</a>`).join("")}</p><section class="kq-consultation"><h2>${esc(CONSULTATION.heading)}</h2><p>${esc(CONSULTATION.description)}</p><p>${esc(CONSULTATION.detail)}</p><div class="kq-actions"><a class="kq-button" href="${CONSULTATION_URL}">${esc(CONSULTATION.action)}</a><a class="kq-back" href="https://www.keyana.sk/collections/${esc(r.collections[0])}">Pozrieť šatky v mojich farbách ↗</a></div><p class="kq-small">${esc(CONSULTATION.note)}</p></section><details class="kq-details"><summary>Ako farby nosiť a vyskúšať doma</summary>${r.outfits.map((p) => `<p>${esc(p)}</p>`).join("")}<p>${esc(r.styling)}</p><p>${esc(r.depthTip)}</p><p>${esc(r.experiment)}</p></details></section>`;
  }
  function resultQuery(r) {
    const params = new URLSearchParams({ palette: r.code });
    if (r.status === "ambiguous")
      params.set("seasons", r.primary_seasons.join(","));
    else if (r.secondary_season) params.set("secondary", r.secondary_season);
    return params.toString();
  }
  async function loadProducts(r, element) {
    const cacheKey = resultQuery(r);
    try {
      let items = productCache.get(cacheKey);
      if (!items) {
        items = (await request(`/v1/products?${cacheKey}`)).products;
        productCache.set(cacheKey, items);
      }
      if (!element.isConnected) return;
      element.innerHTML = items.length
        ? items
            .slice(0, 4)
            .map(
              (p) =>
                `<article class="kq-product"><a href="${esc(safeUrl(p.url))}">${p.image ? `<img src="${esc(safeUrl(p.image, true))}" alt="${esc(p.title)}" width="520" height="520" loading="lazy">` : '<div class="kq-no-image">KEYANA</div>'}<h3 data-kq-invariant>${esc(p.title)}</h3></a>${Number.isFinite(p.price) ? `<p class="kq-price">${esc(money(p.price))}</p>` : ""}<p>${esc(p.reason)}</p><a class="kq-text-link" href="${esc(safeUrl(p.url))}">Pozrieť šatku ↗</a></article>`,
            )
            .join("")
        : "<p>Aktuálny výber nájdete v kolekciách nižšie.</p>";
      localizeDom(element, locale);
      element.classList.toggle("kq-products-four", items.length === 4);
    } catch (e) {
      console.warn("Colour guide: product selection unavailable.", e.name);
      if (element.isConnected)
        element.innerHTML =
          "<p>Výber sa teraz nenačítal. Šatky nájdete v kolekciách nižšie.</p>";
      localizeDom(element, locale);
    }
  }
  function render() {
    try {
      return renderCanonical();
    } finally {
      localizeDom(root, locale);
    }
  }
  function renderCanonical() {
    clearTimeout(deliveryTimer);
    if (review) return renderReview();
    if (state.phase === "intro") {
      root.innerHTML =
        notice +
        `<section class="kq-hero"><div class="kq-hero-copy"><p class="kq-eyebrow">FAREBNÝ KVÍZ KEYANA</p><h1 data-focus tabindex="-1">Objavte farby, ktoré vám pristanú</h1><p class="kq-lead">Odpovedzte na <strong>5 krátkych otázok</strong> a zistite, ku ktorej farebnej palete máte najbližšie.</p><p class="kq-lead">Nejde o farby, ktoré máte najradšej. Myslite na farby, <strong>pri ktorých vaša tvár vyzerá sviežo a pleť rovnomernejšie.</strong></p><button class="kq-button" data-start>Objaviť moju paletu <span aria-hidden="true">→</span></button></div></section><div class="kq-season-images" aria-hidden="true">${["jar", "leto", "jesen", "zima"].map((s) => `<img src="https://cdn.shopify.com/s/files/1/0998/7329/2662/files/${s}.jpg?v=1781761978" alt="" width="600" height="600" loading="lazy">`).join("")}</div><div class="kq-intro-notes"><article><span>01 / VAŠA PRIRODZENÁ FAREBNOSŤ</span><p>Začneme prirodzenou farbou vlasov a očí.</p></article><article><span>02 / FARBY PRI TVÁRI</span><p>Farebné ukážky vám pomôžu porovnať odtiene. Myslite na svoju tvár, nie na obľúbenú farbu.</p></article><article><span>03 / VAŠA PALETA</span><p>E-mailom získate orientačný výsledok a výber hodvábnych šatiek KEYANA. Kvíz nenahrádza osobnú farebnú analýzu.</p></article></div>`;
      root.querySelector("[data-start]").onclick = () => {
        state.index = 0;
        go("question");
      };
      return;
    }
    if (state.phase === "question") {
      const q = QUESTIONS[state.index] || QUESTIONS[0];
      root.innerHTML =
        notice +
        `<section class="kq-question ${q.visual ? "kq-question-visual" : ""}"><div class="kq-step"><span>OTÁZKA ${state.index + 1} / 5</span><span>VAŠA FAREBNÁ PALETA</span></div><progress value="${state.index + 1}" max="5" aria-label="Postup dotazníka"></progress><form><fieldset><legend><span data-focus tabindex="-1">${esc(q.label)}</span></legend>${q.help ? `<p class="kq-help">${esc(q.help)}</p>` : ""}<div class="kq-options ${q.visual ? `kq-options-${q.visual}` : ""}">${optionMarkup(q, state.answers[q.id])}</div></fieldset><p data-message role="status" class="kq-message"></p><div class="kq-actions"><button type="button" class="kq-back" data-back>← Späť</button><button class="kq-button" type="submit">Pokračovať →</button></div></form><p class="kq-small">Vyberte jednu možnosť. Vrátiť sa môžete kedykoľvek.</p></section>`;
      const form = root.querySelector("form");
      form.onchange = () => {
        state.answers[q.id] = form.querySelector("input:checked").value;
        delete state.result;
        delete state.token;
        delete state.subscription;
        delete state.completionTracking;
        history.replaceState(null, "", quizHistoryPath(location));
        state.requestId = crypto.randomUUID();
        persist();
        message("");
      };
      root.querySelector("[data-back]").onclick = () => {
        if (state.index === 0) go("intro");
        else {
          state.index--;
          go("question");
        }
      };
      form.onsubmit = (e) => {
        e.preventDefault();
        if (!state.answers[q.id]) return message("Vyberte jednu možnosť.");
        if (state.index < 4) {
          state.index++;
          go("question");
        } else {
          try {
            validateAnswers(state.answers);
            go("email");
          } catch (e) {
            message(e.message);
          }
        }
      };
      return;
    }
    if (state.phase === "email") {
      root.innerHTML =
        notice +
        `<section class="kq-question kq-email-step"><p class="kq-eyebrow">5 / 5 · HOTOVO</p><h1 data-focus tabindex="-1">Vašu farebnú paletu pripravujeme</h1><p class="kq-lead">Zadajte svoj e-mail. Pošleme Vám orientačný výsledok, tipy na nosenie farieb a výber hodvábnych šatiek KEYANA, vo farbách, ktoré by Vám mohli pristať. Odber noviniek je dobrovoľný.</p><form class="kq-gate"><label for="kq-email">Váš e-mail</label><input id="kq-email" name="email" type="email" autocomplete="email" maxlength="254" required aria-describedby="kq-email-typo" placeholder="vas@email.sk"><div id="kq-email-typo" data-email-typo hidden><p class="kq-message" role="status">V e-mailovej adrese môže byť preklep. Skontrolujte doménu za znakom @.</p><div class="kq-actions"><button type="button" class="kq-back" data-email-correct></button><button type="button" class="kq-back" data-email-keep>Ponechať zadanú adresu</button></div></div><div class="kq-trap" aria-hidden="true"><label>Web<input name="website" tabindex="-1" autocomplete="off"></label></div><label class="kq-consent"><input type="checkbox" name="consent"><span>${esc(CONSENT)} <a href="https://www.keyana.sk/policies/privacy-policy" target="_blank" rel="noopener">Ochrana osobných údajov</a>.</span></label><button class="kq-button" type="submit">Poslať moju farebnú paletu →</button><p data-message role="status" class="kq-message"></p><button type="button" class="kq-back" data-back>← Späť k otázkam</button></form></section>`;
      const form = root.querySelector("form");
      const emailTypo = createEmailTypoGuard({
        input: form.email,
        panel: form.querySelector("[data-email-typo]"),
        translate: t,
        onChange: () => form.oninput(),
      });
      form.oninput = () => {
        emailTypo.reset();
        state.requestId = crypto.randomUUID();
        delete state.completionTracking;
        persist();
      };
      root.querySelector("[data-back]").onclick = () => {
        if (!busy) {
          state.index = 4;
          go("question");
        }
      };
      form.onsubmit = async (e) => {
        e.preventDefault();
        if (busy || !emailTypo.check()) return;
        busy = true;
        const button = form.querySelector("[type=submit]");
        button.disabled = true;
        message("Pripravujeme váš výsledok…");
        try {
          const saved = await request("/v1/complete", {
            requestId: state.requestId,
            version: VERSION,
            answers: state.answers,
            email: form.email.value.trim(),
            marketingConsent: form.consent.checked,
            attribution: attributionSnapshot(),
            consentVersion: CONSENT_VERSION,
            website: form.website.value,
          });
          state.token = saved.token;
          delete state.result;
          state.delivery = saved.delivery;
          state.subscription = saved.subscription;
          // Meta's existing pixel reads the current URL. Remove arbitrary
          // query data and old result fragments before recording completion.
          try {
            history.replaceState(null, "", quizHistoryPath(location));
          } catch {
            /* The tracker fails closed if this URL could contain private data. */
          }
          completionTracking.recordSuccessfulCompletion();
          if (preview)
            state.subscription = {
              message:
                "Lokálna ukážka. Údaje zostali v lokálnej bete; žiadny e-mail ani odber nevznikol.",
            };
          // The delivery token is already persisted in this tab's session.
          // Keep it out of automatic partner page-view URLs after completion.
          go("result");
        } catch (e) {
          message(e.message);
        } finally {
          busy = false;
          button.disabled = false;
        }
      };
      return;
    }
    if (state.phase === "result" && state.token) {
      const delivery = state.delivery || { status: "not_requested" };
      const messages = {
        queued: [
          "Vaša farebná paleta je na ceste",
          "E-mail pripravujeme na odoslanie. Nájdete v ňom svoju paletu, tipy na nosenie farieb aj vybrané šatky KEYANA.",
        ],
        sending: [
          "Vaša farebná paleta je na ceste",
          "E-mail práve odosielame. O chvíľu si skontrolujte doručenú poštu.",
        ],
        accepted: [
          "Vašu farebnú paletu sme odoslali",
          "Skontrolujte si e-mail vrátane priečinkov Reklamy a Spam. Potvrdenie doručenia ešte čakáme.",
        ],
        delivered: [
          "Vaša farebná paleta je v e-maile",
          "Poštový server potvrdil doručenie. Ak správu nevidíte, pozrite aj priečinky Reklamy a Spam.",
        ],
        ambiguous: [
          "Overujeme odoslanie e-mailu",
          "Odoslanie zatiaľ nevieme potvrdiť. Skontrolujte si schránku; ďalšiu správu teraz neposielame, aby Vám neprišla dvakrát.",
        ],
        failed: [
          "E-mail sa nepodarilo doručiť",
          "Ak je opätovné odoslanie dostupné, skúste ho nižšie. Pri pretrvávajúcom probléme nás kontaktujte na jana@keyana.sk.",
        ],
        blocked: [
          "E-mail na túto adresu nemôžeme odoslať",
          "Doručovanie na túto adresu bolo pozastavené. Kontaktujte nás na jana@keyana.sk.",
        ],
        cancelled: [
          "Odoslanie e-mailu bolo zastavené",
          "Ak si chcete vyžiadať výsledok, použite formulár nižšie alebo nás kontaktujte na jana@keyana.sk.",
        ],
        not_requested: [
          "Vaša farebná paleta patrí do e-mailu",
          "Výsledky už zobrazujeme iba v e-maile. Ak ste svoj výsledok ešte nedostali, vyžiadajte si ho na pôvodnú adresu nižšie.",
        ],
        waiting_result: [
          "Vašu požiadavku evidujeme",
          "Stav odoslania si môžete overiť obnovením stránky.",
        ],
      };
      const [heading, description] = preview
        ? [
            "Ukážka potvrdenia",
            "Lokálna ukážka neposiela e-maily. Výsledky a e-maily nájdete v prehľade pre Janku.",
          ]
        : delivery.paused
          ? [
              "Vašu požiadavku sme uložili",
              "Odosielanie e-mailov je dočasne pozastavené. Stav si môžete overiť neskôr.",
            ]
          : messages[delivery.status] || messages.not_requested;
      root.innerHTML =
        notice +
        `<section class="kq-question kq-email-step kq-delivery"><p class="kq-eyebrow">FAREBNÝ KVÍZ KEYANA</p><h1 data-focus tabindex="-1">${esc(heading)}</h1><p class="kq-lead">${esc(description)}</p>${subscriptionMarkup()}<div class="kq-actions"><a class="kq-button" href="https://www.keyana.sk/collections/all">Pozrieť hodvábne šatky →</a></div><p data-message role="status" class="kq-message"></p>${delivery.canResend && !preview ? `<details class="kq-details"><summary>${delivery.status === "not_requested" ? "Vyžiadať výsledok e-mailom" : "E-mail neprišiel?"}</summary><p>Zadajte Vašu e-mailovú adresu znovu.</p><form class="kq-gate" data-resend><label for="kq-resend-email">Váš e-mail</label><input id="kq-resend-email" name="email" type="email" autocomplete="email" required maxlength="254"><div class="kq-trap" aria-hidden="true"><label>Web<input name="website" tabindex="-1" autocomplete="off"></label></div><button type="submit" class="kq-button">Poslať výsledok e-mailom →</button><p data-resend-message role="status" class="kq-message"></p></form></details>` : ""}<div class="kq-result-bottom"><button class="kq-back" data-reset>Začať nový kvíz</button></div></section>`;
      root.querySelector("[data-reset]").onclick = reset;
      const refresh = async () => {
        const token = state.token;
        try {
          const saved = await request(
            `/v1/results/${encodeURIComponent(token)}`,
          );
          if (state.phase !== "result" || state.token !== token) return;
          state.delivery = saved.delivery;
          delete state.result;
          persist();
          render();
        } catch (e) {
          message(e.message);
        }
      };
      if (
        ["queued", "sending", "accepted"].includes(delivery.status) &&
        !delivery.paused &&
        !delivery.canResend &&
        !preview
      )
        deliveryTimer = setTimeout(refresh, 15000);
      const form = root.querySelector("[data-resend]");
      if (form)
        form.onsubmit = async (e) => {
          e.preventDefault();
          if (busy) return;
          busy = true;
          const button = form.querySelector("button");
          button.disabled = true;
          try {
            const saved = await request("/v1/resend", {
              resultToken: state.token,
              email: form.email.value.trim(),
              website: form.website.value,
            });
            state.delivery = saved.delivery;
            go("result");
          } catch (e) {
            form.querySelector("[data-resend-message]").textContent = t(
              e.message,
            );
          } finally {
            busy = false;
            button.disabled = false;
          }
        };
    }
  }

  function renderReview() {
    const scenarios = SEASONS.flatMap((code) => [
      { code, secondary: null },
      ...SEASONS.filter((s) => s !== code).map((secondary) => ({
        code,
        secondary,
      })),
    ]);
    for (let mask = 1; mask < 16; mask++) {
      const seasons = SEASONS.filter((_, i) => mask & (1 << i));
      if (seasons.length > 1) scenarios.push({ code: "ambiguous", seasons });
    }
    root.innerHTML =
      notice +
      `<section class="kq-review"><p class="kq-eyebrow">PRACOVNÝ PREHĽAD PRE JANKU · V1.1</p><h1 data-focus tabindex="-1">Päť otázok. Vaša farebná stopa.</h1><p class="kq-lead">Otázky, bodovanie, farebné ukážky a výsledky podľa zadania KVIZ KEYANA. Tento prehľad neukladá odpovede, neprihlasuje na odber a neposiela e-maily.</p><a class="kq-button" href="${location.pathname}">Prejsť skutočný dotazník →</a><h2>Otázky a farebné ukážky</h2>${QUESTIONS.map((q) => `<details class="kq-details"><summary>${q.id.toUpperCase()} · ${esc(q.label)}</summary>${q.help ? `<p>${esc(q.help)}</p>` : ""}<div class="kq-review-options">${q.options.map((o) => `<div class="kq-option"><span class="kq-option-content">${o.value}) ${esc(o.label)}${optionColors(q, o)}</span></div>`).join("")}</div><table class="kq-score-table"><thead><tr><th>Odpoveď</th>${SEASONS.map((s) => `<th>${SEASON_NAMES[s]}</th>`).join("")}</tr></thead><tbody>${q.options.map((o) => `<tr><th>${o.value}</th>${o.points.map((p) => `<td>${p}</td>`).join("")}</tr>`).join("")}</tbody></table></details>`).join("")}<h2>Vyhodnotenie</h2><p>Najvyšší súčet určí hlavnú paletu. Presah sa zobrazí iba pri rozdiele najviac 2 body: Q3=A len Jar/Jeseň, Q3=D len Leto/Zima, Q3=B/C aj medzi teplými a chladnými paletami. Pri Q3=E alebo rovnako silných sekundárnych možnostiach zostane iba hlavná paleta.</p><p>Pri rovnosti najvyššieho skóre uvedieme všetky zhodné palety ako neistý výsledok. Žiadnu z nich nevyberáme ako jedinú hlavnú. Body sa zákazníčke nezobrazujú.</p><h2>Výsledky a e-maily</h2><p>Ukážky hlavných paliet, presahov a nerozhodných výsledkov s dvoma až štyrmi paletami.</p>${scenarios.map(({ code, secondary, seasons }) => `<details class="kq-details" data-review="${code}" data-secondary="${secondary || ""}" data-seasons="${seasons?.join(",") || ""}"><summary>${seasons ? "Remíza: " + seasons.map((s) => SEASON_NAMES[s]).join(" / ") : SEASON_NAMES[code]}${secondary ? ` + ${SEASON_NAMES[secondary]}` : ""}</summary><div data-review-body></div></details>`).join("")}<p class="kq-small">Verzia: ${VERSION}. Marketingový súhlas je dobrovoľný; samotné zadanie e-mailu nikoho neprihlasuje do Mailchimpu.</p></section>`;
    for (const d of root.querySelectorAll("[data-review]"))
      d.addEventListener("toggle", () => {
        if (!d.open || d.dataset.loaded) return;
        d.dataset.loaded = "true";
        const code = d.dataset.review,
          secondary = d.dataset.secondary || null,
          r =
            code === "ambiguous"
              ? resultForTie(d.dataset.seasons.split(","))
              : resultForSeason(code, secondary),
          target = d.querySelector("[data-review-body]");
        target.innerHTML =
          resultMarkup(r, true) +
          `<div class="kq-email-links">${[
            ["result", "E-mail: výsledok"],
            ["day2", "E-mail: deň 2"],
            ["day5", "E-mail: deň 5"],
          ]
            .map(
              ([kind, label]) =>
                `<a class="kq-back" target="_blank" rel="noopener" href="${esc(api)}/review/email?${esc(resultQuery(r))}&kind=${kind}">${label} ↗</a>`,
            )
            .join("")}</div>`;
        localizeDom(target, locale);
        loadProducts(r, target.querySelector("[data-products]"));
      });
  }
  async function boot() {
    const token = location.hash.startsWith("#r=")
      ? location.hash.slice(3)
      : null;
    if (token && !review) {
      try {
        const saved = await request(`/v1/results/${encodeURIComponent(token)}`);
        state = {
          ...fresh(),
          ...(state.token === token
            ? { answers: state.answers, subscription: state.subscription }
            : {}),
          phase: "result",
          delivery: saved.delivery,
          token,
        };
        persist();
      } catch (e) {
        root.innerHTML =
          notice +
          `<section class="kq-question"><h1>Začnime znova</h1><p>${esc(e.message)}</p><a class="kq-button" href="${location.pathname}">Otvoriť kvíz</a></section>`;
        localizeDom(root, locale);
        return;
      }
    }
    delete state.result;
    render();
  }
  boot();
}

})();
